import { ServiceFeature } from '../types/serviceTypes';

// Objeto con detalles de todas las características de servicios
export const featureDetails: Record<string, ServiceFeature> = {
  'Registro en plataformas clave': {
    name: 'Registro en plataformas clave',
    description:
      'Creamos y optimizamos perfiles profesionales de su empresa en las principales plataformas digitales como Google My Business, Bing Places, Apple Maps, Facebook Business, LinkedIn, TripAdvisor, Yelp y directorios específicos de su industria. Cada perfil es cuidadosamente configurado con información precisa, consistente y optimizada para maximizar su visibilidad y facilitar que potenciales clientes encuentren su negocio.',
    benefits: [
      {
        title: 'Visibilidad multiplataforma',
        description:
          'Presencia simultánea en las plataformas más relevantes donde sus clientes buscan servicios',
      },
      {
        title: 'Consistencia de marca',
        description: 'Información uniforme y profesional en todos los perfiles digitales',
      },
      {
        title: 'Posicionamiento local',
        description: 'Mejora significativa en resultados de búsquedas locales y mapas digitales',
      },
      {
        title: 'Credibilidad aumentada',
        description: 'Perfiles verificados que generan confianza en potenciales clientes',
      },
    ],
  },
  'Optimización de perfiles': {
    name: 'Optimización de perfiles',
    description:
      'Refinamos cada perfil digital con elementos estratégicos como palabras clave relevantes, descripciones persuasivas, categorías precisas, horarios actualizados, atributos destacados y contenido multimedia de alta calidad. Implementamos técnicas avanzadas de SEO local para mejorar el posicionamiento en búsquedas geográficamente relevantes y aumentar la probabilidad de conversión de visitantes en clientes.',
    benefits: [
      {
        title: 'Mayor relevancia en búsquedas',
        description: 'Mejora de hasta 70% en posicionamiento para términos clave de su industria',
      },
      {
        title: 'Experiencia visual atractiva',
        description: 'Contenido multimedia profesional que destaca frente a la competencia',
      },
      {
        title: 'Información estratégica',
        description: 'Descripciones y atributos orientados a conversión y diferenciación',
      },
      {
        title: 'Actualización continua',
        description: 'Mantenimiento proactivo de información para reflejar cambios en su negocio',
      },
    ],
  },
  'Gestión de reputación online': {
    name: 'Gestión de reputación online',
    description:
      'Implementamos un sistema integral para monitorear, gestionar y mejorar la reputación digital de su empresa. Configuramos alertas para nuevas reseñas, desarrollamos protocolos de respuesta para feedback tanto positivo como negativo, y creamos estrategias proactivas para incentivar valoraciones positivas de clientes satisfechos. Nuestro enfoque transforma la percepción online en una ventaja competitiva tangible.',
    benefits: [
      {
        title: 'Monitoreo en tiempo real',
        description: 'Alertas inmediatas sobre nuevas menciones y reseñas en todas las plataformas',
      },
      {
        title: 'Respuestas profesionales',
        description: 'Gestión estratégica de comentarios que refuerza la imagen de marca',
      },
      {
        title: 'Incremento de valoraciones positivas',
        description:
          'Estrategias efectivas para aumentar el volumen y calidad de reseñas favorables',
      },
      {
        title: 'Mitigación de crisis',
        description: 'Protocolos establecidos para gestionar eficazmente feedback negativo',
      },
    ],
  },
  'Estrategia de contenido': {
    name: 'Estrategia de contenido',
    description:
      'Desarrollamos un plan estratégico de contenido para sus perfiles digitales que incluye publicaciones regulares, ofertas especiales, actualizaciones de productos/servicios y contenido estacional relevante. Creamos un calendario editorial personalizado que mantiene su presencia digital activa y atractiva, generando engagement continuo con su audiencia y reforzando su posicionamiento como referente en su sector.',
    benefits: [
      {
        title: 'Engagement constante',
        description: 'Interacción regular con su audiencia mediante contenido relevante y oportuno',
      },
      {
        title: 'Autoridad sectorial',
        description: 'Posicionamiento como experto en su industria mediante contenido de valor',
      },
      {
        title: 'Visibilidad algorítmica',
        description: 'Mayor prioridad en feeds y resultados por actividad regular y relevante',
      },
      {
        title: 'Oportunidades comerciales',
        description: 'Promoción estratégica de ofertas y servicios en momentos óptimos',
      },
    ],
  },
  'Monitoreo de visibilidad': {
    name: 'Monitoreo de visibilidad',
    description:
      'Implementamos herramientas avanzadas de análisis para rastrear y medir el rendimiento de su presencia digital. Monitorizamos métricas clave como impresiones, interacciones, clics a sitio web, llamadas generadas, solicitudes de indicaciones y comparativas con competidores. Proporcionamos informes periódicos con insights accionables que permiten ajustar estrategias y maximizar el retorno de su inversión digital.',
    benefits: [
      {
        title: 'Métricas transparentes',
        description: 'Acceso a datos precisos sobre el rendimiento de cada plataforma digital',
      },
      {
        title: 'Análisis competitivo',
        description: 'Comparativas con competidores directos para identificar oportunidades',
      },
      {
        title: 'Optimización basada en datos',
        description: 'Ajustes estratégicos fundamentados en comportamiento real de usuarios',
      },
      {
        title: 'ROI demostrable',
        description: 'Cuantificación clara del impacto comercial de su presencia digital',
      },
    ],
  },
  'Chatbots inteligentes': {
    name: 'Chatbots inteligentes',
    description:
      'Desarrollamos asistentes virtuales avanzados que utilizan inteligencia artificial y procesamiento de lenguaje natural para mantener conversaciones fluidas y naturales con tus clientes. Nuestros chatbots aprenden continuamente de cada interacción, mejorando su capacidad para resolver consultas complejas, entender el contexto conversacional y proporcionar respuestas precisas y personalizadas sin intervención humana.',
    benefits: [
      {
        title: 'Atención 24/7',
        description: 'Servicio ininterrumpido todos los días del año sin costos adicionales',
      },
      {
        title: 'Escalabilidad inmediata',
        description: 'Gestión simultánea de miles de conversaciones sin degradación del servicio',
      },
      {
        title: 'Aprendizaje continuo',
        description: 'Mejora constante basada en interacciones previas y feedback de usuarios',
      },
      {
        title: 'Reducción de costos operativos',
        description: 'Disminución de hasta 70% en gastos de atención al cliente',
      },
    ],
  },
  'Integración multicanal': {
    name: 'Integración multicanal',
    description:
      'Implementamos soluciones de comunicación unificada que conectan tus chatbots con múltiples plataformas y canales de contacto. Integramos perfectamente tu asistente virtual con WhatsApp, Facebook Messenger, Telegram, web, aplicaciones móviles, sistemas de telefonía IP y correo electrónico, permitiendo a tus clientes interactuar a través de su canal preferido mientras mantienes una conversación coherente y contextualizada a través de todos los puntos de contacto.',
    benefits: [
      {
        title: 'Experiencia omnicanal',
        description: 'Conversaciones fluidas que persisten entre diferentes plataformas',
      },
      {
        title: 'Consistencia de marca',
        description: 'Comunicación uniforme independientemente del canal utilizado',
      },
      {
        title: 'Preferencias del usuario',
        description: 'Respeto por el canal de comunicación elegido por cada cliente',
      },
      {
        title: 'Análisis centralizado',
        description: 'Visión unificada de interacciones a través de todos los canales',
      },
    ],
  },
  'Respuestas automáticas': {
    name: 'Respuestas automáticas',
    description:
      'Implementamos sistemas inteligentes que detectan y responden automáticamente a consultas frecuentes, solicitudes de información y situaciones predecibles. Mediante algoritmos de clasificación y reconocimiento de intenciones, nuestras soluciones identifican el propósito de cada mensaje entrante y generan respuestas contextualizadas, precisas y en lenguaje natural, liberando a tu equipo humano para enfocarse en interacciones de mayor valor y complejidad.',
    benefits: [
      {
        title: 'Tiempo de respuesta inmediato',
        description: 'Contestación instantánea sin tiempos de espera',
      },
      {
        title: 'Consistencia informativa',
        description: 'Respuestas estandarizadas y precisas para consultas similares',
      },
      {
        title: 'Derivación inteligente',
        description: 'Transferencia contextualizada a agentes humanos cuando es necesario',
      },
      {
        title: 'Autoservicio eficiente',
        description: 'Resolución de consultas sin intervención de personal',
      },
    ],
  },
  'Análisis de conversaciones': {
    name: 'Análisis de conversaciones',
    description:
      'Transformamos los diálogos con tus clientes en insights accionables mediante tecnologías avanzadas de análisis conversacional. Nuestras soluciones procesan automáticamente miles de interacciones para identificar patrones, sentimientos, temas recurrentes y oportunidades de mejora. Implementamos dashboards interactivos que visualizan tendencias, alertan sobre problemas emergentes y proporcionan recomendaciones basadas en el comportamiento real de tus usuarios.',
    benefits: [
      {
        title: 'Identificación de tendencias',
        description: 'Detección temprana de temas recurrentes y problemas potenciales',
      },
      {
        title: 'Análisis de sentimiento',
        description: 'Evaluación automática de la satisfacción del cliente en cada interacción',
      },
      {
        title: 'Optimización continua',
        description: 'Mejora iterativa de respuestas basada en efectividad histórica',
      },
      {
        title: 'Inteligencia de negocio',
        description: 'Transformación de conversaciones en oportunidades comerciales',
      },
    ],
  },
  'Personalización avanzada': {
    name: 'Personalización avanzada',
    description:
      'Desarrollamos experiencias conversacionales únicas para cada usuario mediante sistemas de personalización contextual. Nuestras soluciones construyen perfiles dinámicos basados en interacciones previas, preferencias manifestadas, comportamiento histórico y datos demográficos, permitiendo a tus chatbots adaptar su tono, contenido y recomendaciones a las necesidades específicas de cada cliente, incrementando significativamente la relevancia y efectividad de cada conversación.',
    benefits: [
      {
        title: 'Experiencia individualizada',
        description: 'Interacciones adaptadas al perfil específico de cada usuario',
      },
      {
        title: 'Anticipación de necesidades',
        description: 'Sugerencias proactivas basadas en patrones de comportamiento',
      },
      {
        title: 'Fidelización mejorada',
        description: 'Incremento en retención por experiencias relevantes y contextuales',
      },
      {
        title: 'Conversión optimizada',
        description: 'Aumento en tasas de conversión mediante recomendaciones personalizadas',
      },
    ],
  },
  'Control de procesos': {
    name: 'Control de procesos',
    description:
      'Implementamos sistemas avanzados de control de procesos industriales que automatizan y optimizan las operaciones de producción. Mediante la integración de sensores, actuadores, controladores y software especializado, desarrollamos soluciones que monitorizan variables críticas (temperatura, presión, flujo, nivel) y ejecutan acciones de control precisas en tiempo real, garantizando la estabilidad, eficiencia y calidad de los procesos productivos.',
    benefits: [
      {
        title: 'Optimización de parámetros',
        description: 'Ajuste automático de variables para maximizar rendimiento y calidad',
      },
      {
        title: 'Reducción de variabilidad',
        description: 'Mayor consistencia en productos y procesos mediante control estadístico',
      },
      {
        title: 'Respuesta predictiva',
        description: 'Anticipación a desviaciones antes de que afecten la producción',
      },
      {
        title: 'Eficiencia energética',
        description: 'Minimización del consumo de recursos mediante control preciso',
      },
    ],
  },
  SCADA: {
    name: 'SCADA',
    description:
      'Diseñamos e implementamos sistemas SCADA (Supervisory Control And Data Acquisition) que centralizan la supervisión y control de procesos industriales distribuidos. Mediante interfaces gráficas intuitivas, nuestras soluciones permiten visualizar en tiempo real el estado de la planta, recibir alarmas, analizar tendencias históricas y controlar remotamente equipos y procesos, facilitando la toma de decisiones operativas y mejorando la respuesta ante incidencias.',
    benefits: [
      {
        title: 'Visibilidad integral',
        description: 'Monitorización centralizada de todos los procesos y equipos',
      },
      {
        title: 'Control remoto seguro',
        description: 'Operación de sistemas desde cualquier ubicación con protocolos encriptados',
      },
      {
        title: 'Trazabilidad completa',
        description: 'Registro histórico detallado para análisis y auditorías',
      },
      {
        title: 'Gestión eficiente de alarmas',
        description: 'Priorización y notificación inteligente de eventos críticos',
      },
    ],
  },
  PLC: {
    name: 'PLC',
    description:
      'Desarrollamos soluciones basadas en Controladores Lógicos Programables (PLC) que constituyen el núcleo de la automatización industrial moderna. Programamos estos dispositivos robustos utilizando lenguajes estandarizados (Ladder, SFC, ST) para controlar con precisión maquinaria, líneas de producción y procesos industriales completos. Nuestras implementaciones incluyen comunicación con sensores y actuadores, lógica de control avanzada, secuenciación de operaciones y protocolos de seguridad.',
    benefits: [
      {
        title: 'Fiabilidad industrial',
        description: 'Operación continua en entornos adversos con mínimo mantenimiento',
      },
      {
        title: 'Flexibilidad operativa',
        description: 'Reprogramación rápida para adaptarse a cambios en producción',
      },
      {
        title: 'Integración multisistema',
        description: 'Comunicación con equipos de diferentes fabricantes y generaciones',
      },
      {
        title: 'Diagnóstico avanzado',
        description: 'Identificación precisa de fallos para minimizar tiempos de parada',
      },
    ],
  },
  'Industria 4.0': {
    name: 'Industria 4.0',
    description:
      'Transformamos plantas industriales tradicionales en fábricas inteligentes mediante la implementación de tecnologías de Industria 4.0. Integramos sistemas ciberfísicos, Internet de las Cosas, computación en la nube y análisis de big data para crear entornos productivos hiperconectados donde máquinas, productos y sistemas interactúan de forma autónoma. Nuestras soluciones habilitan la fabricación personalizada, el mantenimiento predictivo y la optimización continua basada en datos.',
    benefits: [
      {
        title: 'Fabricación ágil',
        description: 'Adaptación rápida a cambios de demanda y personalización masiva',
      },
      {
        title: 'Mantenimiento predictivo',
        description: 'Anticipación a fallos mediante análisis de patrones de comportamiento',
      },
      {
        title: 'Gemelos digitales',
        description: 'Simulación virtual de procesos para optimización sin riesgos operativos',
      },
      {
        title: 'Trazabilidad end-to-end',
        description: 'Seguimiento completo desde materias primas hasta producto final',
      },
    ],
  },
  'IoT Industrial': {
    name: 'IoT Industrial',
    description:
      'Implementamos ecosistemas de Internet de las Cosas Industrial (IIoT) que conectan máquinas, sensores y sistemas para crear entornos productivos inteligentes. Mediante dispositivos conectados, gateways industriales y plataformas cloud especializadas, capturamos datos operativos en tiempo real que transformamos en insights accionables. Nuestras soluciones permiten monitorización remota, mantenimiento predictivo, optimización energética y nuevos modelos de servitización industrial.',
    benefits: [
      {
        title: 'Visibilidad en tiempo real',
        description: 'Monitorización continua de activos distribuidos geográficamente',
      },
      {
        title: 'Analítica avanzada',
        description: 'Identificación de patrones y anomalías mediante algoritmos especializados',
      },
      {
        title: 'Optimización autónoma',
        description: 'Ajustes automáticos basados en condiciones operativas cambiantes',
      },
      {
        title: 'Nuevos modelos de negocio',
        description: 'Habilitación de servicios basados en datos y resultados',
      },
    ],
  },
  'Machine Learning': {
    name: 'Machine Learning',
    description:
      'Desarrollamos modelos de aprendizaje automático personalizados que identifican patrones complejos en tus datos empresariales. Implementamos algoritmos avanzados (regresión, árboles de decisión, redes neuronales) adaptados a tus objetivos específicos, permitiéndote automatizar procesos de toma de decisiones, optimizar operaciones y descubrir insights ocultos en grandes volúmenes de información.',
    benefits: [
      {
        title: 'Decisiones basadas en datos',
        description: 'Eliminación del sesgo humano en procesos críticos',
      },
      {
        title: 'Escalabilidad analítica',
        description: 'Procesamiento eficiente de volúmenes crecientes de información',
      },
      {
        title: 'Adaptabilidad continua',
        description: 'Modelos que mejoran con el tiempo al procesar nuevos datos',
      },
      {
        title: 'Automatización inteligente',
        description: 'Reducción de tareas manuales mediante sistemas que aprenden',
      },
    ],
  },
  'Procesamiento de lenguaje natural': {
    name: 'Procesamiento de lenguaje natural',
    description:
      'Implementamos tecnologías que permiten a tus sistemas comprender, interpretar y generar lenguaje humano. Mediante algoritmos avanzados de NLP, desarrollamos soluciones como chatbots inteligentes, análisis de sentimiento en redes sociales, clasificación automática de documentos y extracción de información relevante de textos no estructurados, facilitando la interacción natural entre humanos y máquinas.',
    benefits: [
      {
        title: 'Atención al cliente 24/7',
        description: 'Asistentes virtuales que responden consultas en cualquier momento',
      },
      {
        title: 'Análisis de feedback',
        description: 'Comprensión automática de opiniones y sentimientos de clientes',
      },
      {
        title: 'Gestión documental inteligente',
        description: 'Clasificación y extracción de información clave de documentos',
      },
      {
        title: 'Comunicación multilingüe',
        description: 'Eliminación de barreras idiomáticas en operaciones globales',
      },
    ],
  },
  'Visión computacional': {
    name: 'Visión computacional',
    description:
      'Dotamos a tus sistemas de la capacidad de "ver" e interpretar el mundo visual. Mediante redes neuronales convolucionales y técnicas de deep learning, desarrollamos soluciones que pueden reconocer objetos, detectar anomalías, analizar imágenes médicas, automatizar inspecciones de calidad o monitorear espacios físicos, transformando datos visuales en información accionable para tu negocio.',
    benefits: [
      {
        title: 'Control de calidad automatizado',
        description: 'Detección precisa de defectos en líneas de producción',
      },
      {
        title: 'Seguridad mejorada',
        description: 'Monitoreo inteligente de espacios y detección de situaciones anómalas',
      },
      {
        title: 'Experiencias interactivas',
        description: 'Interfaces que responden a gestos y expresiones faciales',
      },
      {
        title: 'Digitalización eficiente',
        description:
          'Conversión automática de documentos físicos a formatos digitales estructurados',
      },
    ],
  },
  'Automatización cognitiva': {
    name: 'Automatización cognitiva',
    description:
      'Elevamos la automatización tradicional incorporando capacidades cognitivas que emulan el pensamiento humano. Combinamos tecnologías como RPA (Robotic Process Automation) con inteligencia artificial para crear sistemas que no solo ejecutan tareas repetitivas, sino que también toman decisiones basadas en contexto, aprenden de excepciones y se adaptan a situaciones cambiantes, liberando a tu equipo para enfocarse en actividades de mayor valor.',
    benefits: [
      {
        title: 'Procesos adaptativos',
        description: 'Sistemas que aprenden y mejoran con cada interacción',
      },
      {
        title: 'Reducción de errores',
        description: 'Eliminación de fallos humanos en tareas complejas y repetitivas',
      },
      {
        title: 'Escalabilidad operativa',
        description:
          'Capacidad para gestionar volúmenes variables de trabajo sin recursos adicionales',
      },
      {
        title: 'Integración inteligente',
        description: 'Conexión fluida entre sistemas dispares mediante comprensión contextual',
      },
    ],
  },
  'Arquitectura empresarial': {
    name: 'Arquitectura empresarial',
    description:
      'Diseñamos e implementamos estructuras tecnológicas robustas que alinean tus sistemas de información con los objetivos estratégicos de tu organización. Mediante metodologías como TOGAF, Zachman o DoDAF, creamos frameworks arquitectónicos que integran aplicaciones, datos, infraestructura y seguridad en un ecosistema coherente y escalable, facilitando la transformación digital y optimizando la gestión de recursos tecnológicos.',
    benefits: [
      {
        title: 'Alineación estratégica',
        description: 'Tecnología perfectamente alineada con objetivos de negocio',
      },
      {
        title: 'Reducción de complejidad',
        description: 'Simplificación del panorama tecnológico corporativo',
      },
      {
        title: 'Optimización de inversiones',
        description: 'Mayor retorno de la inversión en tecnología',
      },
      {
        title: 'Adaptabilidad al cambio',
        description: 'Estructuras flexibles que evolucionan con el negocio',
      },
    ],
  },
  'Sistemas distribuidos': {
    name: 'Sistemas distribuidos',
    description:
      'Desarrollamos soluciones basadas en arquitecturas distribuidas que dividen las cargas de trabajo entre múltiples nodos interconectados. Implementamos tecnologías como microservicios, contenedores (Docker, Kubernetes) y sistemas de mensajería asíncrona (Kafka, RabbitMQ) para crear aplicaciones resilientes que operan de manera coordinada a través de diferentes ubicaciones geográficas, garantizando continuidad operativa incluso ante fallos parciales del sistema.',
    benefits: [
      {
        title: 'Tolerancia a fallos',
        description: 'Operación continua incluso cuando componentes individuales fallan',
      },
      {
        title: 'Rendimiento optimizado',
        description: 'Distribución eficiente de cargas de procesamiento',
      },
      {
        title: 'Despliegue independiente',
        description: 'Actualización de componentes sin afectar al sistema completo',
      },
      {
        title: 'Escalado horizontal',
        description: 'Capacidad para añadir recursos según demanda específica',
      },
    ],
  },
  'Alta disponibilidad': {
    name: 'Alta disponibilidad',
    description:
      'Implementamos arquitecturas redundantes que garantizan un tiempo de actividad cercano al 100% para tus aplicaciones críticas. Mediante técnicas como clustering, balanceo de carga, replicación de datos y sistemas de conmutación por error automatizados, diseñamos soluciones que eliminan puntos únicos de fallo y mantienen la continuidad del servicio incluso durante mantenimientos planificados o incidentes inesperados.',
    benefits: [
      {
        title: 'Continuidad operativa',
        description: 'Minimización de interrupciones en servicios críticos',
      },
      {
        title: 'Recuperación automática',
        description: 'Sistemas autorreparables ante fallos detectados',
      },
      {
        title: 'Mantenimiento sin interrupciones',
        description: 'Actualizaciones y mejoras sin tiempo de inactividad',
      },
      {
        title: 'Protección de reputación',
        description: 'Prevención de pérdidas por caídas de servicio',
      },
    ],
  },
  Escalabilidad: {
    name: 'Escalabilidad',
    description:
      'Diseñamos sistemas que crecen eficientemente con tu negocio, adaptándose a incrementos en usuarios, transacciones o volumen de datos sin degradar el rendimiento. Implementamos arquitecturas elásticas que permiten escalar vertical (aumentando recursos de servidores existentes) u horizontalmente (añadiendo más servidores), utilizando tecnologías cloud-native, bases de datos distribuidas y patrones de diseño que facilitan la expansión sin necesidad de reescribir aplicaciones.',
    benefits: [
      {
        title: 'Crecimiento sin límites',
        description: 'Expansión fluida según las necesidades del negocio',
      },
      {
        title: 'Optimización de costos',
        description: 'Recursos ajustados a la demanda real en cada momento',
      },
      {
        title: 'Experiencia de usuario consistente',
        description: 'Rendimiento estable independientemente de la carga',
      },
      {
        title: 'Preparación para picos',
        description: 'Capacidad de absorber aumentos súbitos de demanda',
      },
    ],
  },
  'Integración con sistemas legacy': {
    name: 'Integración con sistemas legacy',
    description:
      'Conectamos tus aplicaciones heredadas con tecnologías modernas, extendiendo su vida útil y maximizando el retorno de inversiones pasadas. Mediante el desarrollo de APIs, middleware personalizado, adaptadores y capas de abstracción, creamos puentes entre sistemas antiguos y nuevas plataformas, permitiendo que coexistan y compartan datos de manera eficiente sin necesidad de migraciones costosas y arriesgadas.',
    benefits: [
      {
        title: 'Preservación de inversiones',
        description: 'Aprovechamiento de sistemas existentes con nuevas capacidades',
      },
      {
        title: 'Modernización gradual',
        description: 'Evolución tecnológica sin disrupciones operativas',
      },
      {
        title: 'Interoperabilidad total',
        description: 'Comunicación fluida entre sistemas de diferentes generaciones',
      },
      {
        title: 'Reducción de riesgos',
        description: 'Minimización de impactos en procesos críticos establecidos',
      },
    ],
  },
  'Diseño responsivo': {
    name: 'Diseño responsivo',
    description:
      'Desarrollamos sitios web que se adaptan perfectamente a cualquier dispositivo (móviles, tablets, ordenadores) garantizando una experiencia de usuario óptima independientemente del tamaño de pantalla. Utilizamos técnicas modernas como CSS Grid, Flexbox y Media Queries para crear layouts fluidos que mantienen la integridad visual y funcional en todas las resoluciones.',
    benefits: [
      {
        title: 'Experiencia multiplataforma',
        description: 'Navegación consistente en todos los dispositivos',
      },
      {
        title: 'Mejor posicionamiento SEO',
        description: 'Google prioriza sitios optimizados para móviles',
      },
      {
        title: 'Mayor tasa de conversión',
        description: 'Reducción de rebote en usuarios móviles',
      },
      {
        title: 'Mantenimiento simplificado',
        description: 'Una sola base de código para todas las plataformas',
      },
    ],
  },
  'Visualización de datos': {
    name: 'Visualización de datos',
    description:
      'Transformamos datos complejos en representaciones gráficas intuitivas mediante tableros interactivos diseñados para tu industria. Utilizamos herramientas como Power BI, Tableau o Looker Studio para crear visualizaciones dinámicas (heatmaps, gráficos de tendencia, mapas georeferenciados) que permiten identificar patrones, outliers y oportunidades en tiempo real.',
    benefits: [
      {
        title: 'Personalización de layouts',
        description:
          'Paletas de colores y niveles de detalle según roles (ejecutivo vs. operativo)',
      },
      {
        title: 'Eficiencia en la extracción de insights',
        description: 'Mediante filtros interactivos y drill-down contextual',
      },
      {
        title: 'Valor agregado',
        description: 'Democratizar el acceso a datos estratégicos en toda la organización',
      },
    ],
  },
  'KPIs personalizados': {
    name: 'KPIs personalizados',
    description:
      'Desarrollamos métricas clave adaptadas a tus objetivos estratégicos, desde indicadores financieros (CAC, LTV) hasta operativos (OTD, NPS). Implementamos sistemas de alertas proactivas que notifican desviaciones en los umbrales críticos, permitiendo acciones correctivas inmediatas.',
    benefits: [
      {
        title: 'Personalización en la definición de métricas',
        description: 'Según modelo de negocio y madurez digital',
      },
      {
        title: 'Eficiencia en el monitoreo centralizado',
        description: 'De rendimiento multidepartamental',
      },
      {
        title: 'Valor agregado',
        description: 'Alineación de equipos hacia metas cuantificables',
      },
    ],
  },
  'Generación automática de informes': {
    name: 'Generación automática de informes',
    description:
      'Diseñamos sistemas que recaban y analizan tus datos para generar reportes de manera continua y autónoma. Gracias a esta automatización, tu equipo puede dedicar más tiempo a tareas estratégicas, mientras recibe informes con la información más reciente y relevante para la toma de decisiones.',
    benefits: [
      {
        title: 'Recolección programada de datos',
        description: 'Desde múltiples fuentes',
      },
      {
        title: 'Plantillas de informes personalizables',
        description: '',
      },
      {
        title: 'Actualización periódica',
        description: 'Sin intervención manual',
      },
      {
        title: 'Reducción de errores',
        description: 'Mayor eficiencia operativa',
      },
    ],
  },
  'Distribución programada': {
    name: 'Distribución programada',
    description:
      'Facilitamos la entrega de informes a las personas adecuadas en el momento justo. Con la programación de envíos, cada área o colaborador recibe la información necesaria para actuar de forma ágil, garantizando que no se pasen por alto oportunidades o alertas críticas.',
    benefits: [
      {
        title: 'Envío automático',
        description: 'A correos o plataformas internas',
      },
      {
        title: 'Definición de horarios y frecuencia',
        description: 'De distribución',
      },
      {
        title: 'Segmentación de destinatarios',
        description: 'Por departamento o rol',
      },
      {
        title: 'Trazabilidad y confirmación de entrega',
        description: '',
      },
    ],
  },
  'Personalización de formatos': {
    name: 'Personalización de formatos',
    description:
      'Cada empresa maneja la información de forma distinta. Por ello, adaptamos la presentación de los informes a tus preferencias, ya sea en PDF, Excel, presentaciones interactivas u otros formatos. Así, obtendrás reportes que encajen perfectamente con tus procesos y estilo de comunicación.',
    benefits: [
      {
        title: 'Soporte para diversos formatos de archivo',
        description: '',
      },
      {
        title: 'Diseño de plantillas acorde a tu identidad de marca',
        description: '',
      },
      {
        title: 'Inclusión de gráficos, tablas y diagramas interactivos',
        description: '',
      },
      {
        title: 'Ajuste flexible según requerimientos de cada área',
        description: '',
      },
    ],
  },
  'Integración multiplataforma': {
    name: 'Integración multiplataforma',
    description:
      'Nuestros reportes se conectan con las herramientas que ya utilizas, desde sistemas de gestión y CRMs hasta plataformas de análisis de datos. Esto asegura que tu flujo de trabajo se mantenga centralizado y que los datos viajen de forma segura y fluida entre todas tus aplicaciones.',
    benefits: [
      {
        title: 'Conexión con ERP, CRM y otras bases de datos',
        description: '',
      },
      {
        title: 'Automatización de la transferencia de datos',
        description: '',
      },
      {
        title: 'Sincronización en tiempo real con sistemas externos',
        description: '',
      },
      {
        title: 'Reducción de tareas duplicadas y consistencia de la información',
        description: '',
      },
    ],
  },
  'Análisis de datos en tiempo real': {
    name: 'Análisis de datos en tiempo real',
    description:
      'Implementamos soluciones avanzadas que procesan y analizan tus datos empresariales en el momento exacto en que se generan. Mediante algoritmos de procesamiento de flujos y tecnologías de computación distribuida, transformamos datos brutos en insights accionables instantáneamente, permitiéndote responder a cambios en el mercado, comportamientos de clientes o desviaciones operativas sin los retrasos tradicionales de los sistemas de análisis por lotes.',
    benefits: [
      {
        title: 'Toma de decisiones inmediata',
        description: 'Respuesta ágil a oportunidades o problemas emergentes',
      },
      {
        title: 'Detección temprana de anomalías',
        description: 'Identificación automática de patrones inusuales o desviaciones críticas',
      },
      {
        title: 'Dashboards dinámicos',
        description:
          'Visualizaciones que se actualizan automáticamente con cada nueva entrada de datos',
      },
      {
        title: 'Optimización continua',
        description: 'Ajuste de parámetros operativos basado en retroalimentación constante',
      },
    ],
  },
  'Integración de pagos': {
    name: 'Integración de pagos',
    description:
      'Implementamos soluciones de pago seguras y eficientes en tu sitio web o tienda online. Integramos pasarelas de pago como PayPal, Stripe, Mercado Pago o pasarelas bancarias locales, configurando todo el proceso de checkout para maximizar conversiones y garantizar la seguridad de las transacciones.',
    benefits: [
      {
        title: 'Múltiples métodos de pago',
        description: 'Tarjetas, transferencias, billeteras digitales y más',
      },
      {
        title: 'Seguridad certificada',
        description: 'Cumplimiento con estándares PCI DSS',
      },
      {
        title: 'Experiencia optimizada',
        description: 'Proceso de checkout simplificado para reducir abandonos',
      },
      {
        title: 'Gestión automatizada',
        description: 'Conciliación y reportes de transacciones',
      },
    ],
  },
  'Integración de fuentes': {
    name: 'Integración de fuentes',
    description:
      'Conectamos silos de datos mediante pipelines personalizados que unifican información de ERP, CRM, redes sociales, IoT y APIs externas. Usamos arquitecturas modernas (Lakehouse, Data Mesh) para garantizar calidad, consistencia y gobernanza de datos.',
    benefits: [
      {
        title: 'Personalización en la mapeación de fuentes',
        description: 'Según necesidades analíticas',
      },
      {
        title: 'Eficiencia en la consolidación de datos históricos y en streaming',
        description: '',
      },
      {
        title: 'Valor agregado',
        description: 'Mediante una única fuente de verdad corporativa',
      },
    ],
  },
  'Google My Business': {
    name: 'Google My Business',
    description:
      'Configuramos y optimizamos tu perfil de empresa en Google para mejorar tu visibilidad local. Gestionamos toda la información de tu negocio (ubicación, horarios, fotos, productos/servicios) y te ayudamos a conseguir y gestionar reseñas positivas para destacar en búsquedas locales y Google Maps.',
    benefits: [
      {
        title: 'Visibilidad local',
        description: 'Posicionamiento en búsquedas geográficas relevantes',
      },
      {
        title: 'Información actualizada',
        description: 'Datos precisos sobre tu negocio accesibles 24/7',
      },
      {
        title: 'Gestión de reputación',
        description: 'Monitoreo y respuesta a reseñas de clientes',
      },
      {
        title: 'Análisis de rendimiento',
        description: 'Estadísticas sobre búsquedas, visitas y acciones',
      },
    ],
  },
  'Identidad visual básica': {
    name: 'Identidad visual básica',
    description:
      'Desarrollamos los elementos visuales fundamentales para tu presencia digital, incluyendo selección de paleta de colores, tipografías, iconografía y elementos gráficos básicos. Creamos un sistema visual coherente que refleja la personalidad de tu marca y garantiza consistencia en todas las páginas de tu sitio web.',
    benefits: [
      {
        title: 'Coherencia de marca',
        description: 'Imagen consistente en todos los puntos de contacto digital',
      },
      {
        title: 'Diferenciación visual',
        description: 'Elementos distintivos que te separan de la competencia',
      },
      {
        title: 'Experiencia mejorada',
        description: 'Interfaz atractiva que facilita la navegación',
      },
      {
        title: 'Base escalable',
        description: 'Fundamentos para futuras expansiones de marca',
      },
    ],
  },
  'SEO/SEM avanzado': {
    name: 'SEO/SEM avanzado',
    description:
      'Desarrollamos estrategias integrales de posicionamiento orgánico (SEO) y publicidad en buscadores (SEM) para maximizar tu visibilidad online. Combinamos técnicas avanzadas de optimización on-page y off-page con campañas publicitarias altamente segmentadas para captar tráfico cualificado y aumentar conversiones. Implementamos investigación de palabras clave, optimización técnica, creación de contenido estratégico y construcción de enlaces de calidad.',
    benefits: [
      {
        title: 'Estrategia omnicanal',
        description:
          'Combinación óptima de canales orgánicos y pagados para maximizar alcance e inversión',
      },
      {
        title: 'Segmentación avanzada',
        description:
          'Targeting preciso por ubicación, intereses y comportamiento con análisis demográfico detallado',
      },
      {
        title: 'Optimización continua',
        description:
          'Ajustes basados en análisis de rendimiento con informes periódicos de evolución',
      },
      {
        title: 'ROI medible',
        description:
          'Seguimiento detallado de conversiones y retorno con atribución multicanal avanzada',
      },
    ],
  },
  'SEO técnico': {
    name: 'SEO técnico',
    description:
      'Optimizamos la estructura técnica de tu sitio web para mejorar su visibilidad en los motores de búsqueda. Implementamos mejoras en la velocidad de carga, estructura de URLs, metadatos, esquemas de marcado y arquitectura de la información para facilitar la indexación y mejorar el posicionamiento orgánico.',
    benefits: [
      {
        title: 'Indexación optimizada',
        description: 'Estructura web fácilmente rastreable por buscadores',
      },
      {
        title: 'Velocidad mejorada',
        description: 'Reducción de tiempos de carga para mejor experiencia',
      },
      {
        title: 'Compatibilidad móvil',
        description: 'Optimización para búsquedas desde dispositivos móviles',
      },
      {
        title: 'Datos estructurados',
        description: 'Implementación de schema.org para resultados enriquecidos',
      },
    ],
  },
  'Estrategia de redes sociales': {
    name: 'Estrategia de redes sociales',
    description:
      'Diseñamos y ejecutamos estrategias personalizadas para cada plataforma social (Instagram, Facebook, LinkedIn, TikTok, Twitter) alineadas con tus objetivos de negocio. Desarrollamos calendarios editoriales, creamos contenido de alto impacto, gestionamos comunidades y optimizamos campañas publicitarias para maximizar engagement, alcance y conversiones.',
    benefits: [
      {
        title: 'Contenido estratégico',
        description: 'Creación de contenido adaptado a cada plataforma y audiencia específica',
      },
      {
        title: 'Gestión integral',
        description:
          'Administración completa de perfiles, publicaciones y respuesta a interacciones',
      },
      {
        title: 'Publicidad segmentada',
        description:
          'Campañas de pago optimizadas con segmentación avanzada y presupuestos eficientes',
      },
      {
        title: 'Análisis de competencia',
        description:
          'Monitoreo continuo de competidores y benchmarking de mejores prácticas del sector',
      },
    ],
  },
  'Email marketing': {
    name: 'Email marketing',
    description:
      'Implementamos campañas de email marketing estratégicas y personalizadas para nutrir leads, fidelizar clientes y aumentar ventas. Diseñamos secuencias automatizadas, newsletters, campañas promocionales y de recuperación de carritos abandonados con contenido relevante y segmentado. Utilizamos plataformas avanzadas como Mailchimp, ActiveCampaign o HubSpot para optimizar entregas, tasas de apertura y conversiones.',
    benefits: [
      {
        title: 'Automatización avanzada',
        description: 'Secuencias de emails basadas en comportamiento y etapa del cliente',
      },
      {
        title: 'Segmentación precisa',
        description: 'División de audiencias según intereses, comportamiento y datos demográficos',
      },
      {
        title: 'Diseño optimizado',
        description:
          'Plantillas responsive con elementos visuales atractivos y llamadas a la acción efectivas',
      },
      {
        title: 'Análisis de rendimiento',
        description: 'Informes detallados de tasas de apertura, clics, conversiones y ROI',
      },
    ],
  },
  'Análisis de datos': {
    name: 'Análisis de datos',
    description:
      'Implementamos sistemas avanzados de analítica digital para monitorear, medir y optimizar todas tus estrategias de marketing. Configuramos herramientas como Google Analytics 4, Tag Manager, Data Studio y otras plataformas especializadas para recopilar datos precisos sobre el comportamiento de usuarios, eficacia de campañas y rendimiento de canales. Transformamos datos complejos en insights accionables mediante dashboards personalizados y reportes periódicos.',
    benefits: [
      {
        title: 'Medición integral',
        description:
          'Seguimiento completo del customer journey a través de todos los puntos de contacto',
      },
      {
        title: 'Atribución avanzada',
        description:
          'Modelos personalizados para identificar los canales más efectivos en conversiones',
      },
      {
        title: 'Dashboards interactivos',
        description:
          'Visualizaciones dinámicas con KPIs clave y métricas de rendimiento en tiempo real',
      },
      {
        title: 'Optimización basada en datos',
        description:
          'Recomendaciones estratégicas fundamentadas en análisis estadístico y tendencias',
      },
    ],
  },
  'Google Ads': {
    name: 'Google Ads',
    description:
      'Diseñamos, implementamos y optimizamos campañas publicitarias en la red de Google para maximizar tu visibilidad y conversiones. Desarrollamos estrategias personalizadas en Search, Display, Shopping, YouTube y Discovery con estructuras de cuenta optimizadas, investigación exhaustiva de palabras clave, segmentación avanzada y creatividades de alto impacto. Gestionamos presupuestos de forma eficiente mediante pujas automatizadas y optimización continua basada en datos.',
    benefits: [
      {
        title: 'Estrategia multicanal',
        description:
          'Presencia optimizada en todos los formatos publicitarios de Google según objetivos',
      },
      {
        title: 'Segmentación avanzada',
        description:
          'Targeting preciso por ubicación, dispositivos, horarios, audiencias e intereses',
      },
      {
        title: 'Optimización continua',
        description:
          'Ajustes diarios de pujas, palabras clave y creatividades para maximizar resultados',
      },
      {
        title: 'Reporting transparente',
        description:
          'Informes detallados de rendimiento, costes, conversiones y retorno de inversión',
      },
    ],
  },
  'Evaluación de sistemas': {
    name: 'Evaluación de sistemas',
    description:
      'Analizamos integralmente tu infraestructura tecnológica actual, identificando brechas, obsolescencias y oportunidades de mejora. Nuestra evaluación abarca hardware, software, seguridad informática, integración de sistemas y escalabilidad, garantizando que cada componente esté alineado con tus objetivos estratégicos y las mejores prácticas del sector.',
    benefits: [
      {
        title: 'Personalización en el diagnóstico',
        description: 'Según industria, tamaño y desafíos específicos',
      },
      {
        title: 'Eficiencia en la detección de vulnerabilidades y cuellos de botella operativos',
        description: '',
      },
      {
        title: 'Valor agregado',
        description: 'Mediante propuestas de optimización inmediata y mitigación de riesgos',
      },
    ],
  },
  'Análisis de procesos': {
    name: 'Análisis de procesos',
    description:
      'Evaluación exhaustiva y sistemática de flujos de trabajo, procedimientos operativos y cadenas de valor para identificar oportunidades de mejora, optimización y transformación digital. Mediante metodologías avanzadas como Lean, Six Sigma y BPM (Business Process Management), analizamos cada etapa del proceso para eliminar desperdicios, reducir variabilidad y maximizar la creación de valor para el cliente final.',
    benefits: [
      {
        title: 'Mapeo de procesos',
        description:
          'Documentación detallada y visualización de flujos actuales mediante diagramas BPMN y VSM',
      },
      {
        title: 'Identificación de ineficiencias',
        description:
          'Detección precisa de cuellos de botella, redundancias y actividades sin valor agregado',
      },
      {
        title: 'Análisis de causa raíz',
        description:
          'Investigación profunda de problemas recurrentes utilizando técnicas como 5-Why y diagramas de Ishikawa',
      },
      {
        title: 'Propuestas de mejora',
        description:
          'Recomendaciones estratégicas basadas en mejores prácticas y tecnologías habilitadoras',
      },
    ],
  },
  'Diagnóstico de competencias directivas': {
    name: 'Diagnóstico de competencias directivas',
    description:
      'Evaluación integral de habilidades directivas y de liderazgo mediante herramientas especializadas. Utilizamos metodologías validadas internacionalmente para identificar fortalezas y áreas de mejora en competencias clave como liderazgo, comunicación, toma de decisiones, gestión de conflictos y pensamiento estratégico.',
    benefits: [
      {
        title: 'Evaluación objetiva',
        description: 'Análisis detallado de competencias clave mediante instrumentos validados',
      },
      {
        title: 'Identificación de áreas',
        description: 'Detección precisa de oportunidades de desarrollo profesional',
      },
      {
        title: 'Perfil directivo completo',
        description: 'Mapeo de competencias actuales vs. requeridas para el rol',
      },
      {
        title: 'Feedback constructivo',
        description: 'Retroalimentación estructurada y orientada al crecimiento',
      },
    ],
  },
  'Plan de desarrollo profesional personalizado': {
    name: 'Plan de desarrollo profesional personalizado',
    description:
      'Diseño de programa personalizado de desarrollo ejecutivo alineado con objetivos profesionales y organizacionales. Creamos una hoja de ruta detallada con acciones concretas, recursos específicos y plazos realistas para potenciar las competencias directivas clave identificadas en el diagnóstico inicial.',
    benefits: [
      {
        title: 'Objetivos claros',
        description: 'Definición de metas SMART a corto, mediano y largo plazo',
      },
      {
        title: 'Seguimiento continuo',
        description: 'Monitoreo sistemático de avances con ajustes dinámicos',
      },
      {
        title: 'Desarrollo integral',
        description: 'Equilibrio entre habilidades técnicas, estratégicas y de liderazgo',
      },
      {
        title: 'Recursos personalizados',
        description: 'Acceso a herramientas, bibliografía y formación específica',
      },
    ],
  },
  'Acompañamiento en toma de decisiones estratégicas': {
    name: 'Acompañamiento en toma de decisiones estratégicas',
    description:
      'Asesoramiento experto durante procesos críticos de toma de decisiones empresariales. Proporcionamos un marco metodológico estructurado para analizar alternativas, evaluar riesgos y seleccionar las mejores opciones estratégicas, combinando herramientas analíticas con la experiencia práctica de nuestros consultores senior.',
    benefits: [
      {
        title: 'Análisis multidimensional',
        description: 'Evaluación de impactos financieros, operativos y estratégicos',
      },
      {
        title: 'Mitigación de riesgos',
        description: 'Identificación temprana de obstáculos potenciales',
      },
      {
        title: 'Perspectiva externa',
        description: 'Visión objetiva y libre de sesgos organizacionales',
      },
      {
        title: 'Metodología estructurada',
        description: 'Proceso sistemático para decisiones complejas',
      },
    ],
  },
  'Acompañamiento en toma de decisiones': {
    name: 'Acompañamiento en toma de decisiones',
    description:
      'Proporcionamos soporte estratégico personalizado para ejecutivos en momentos críticos de decisión empresarial. Mediante metodologías estructuradas de análisis y evaluación, combinadas con nuestra experiencia en diversos sectores, ayudamos a identificar, evaluar y seleccionar las mejores opciones estratégicas. Nuestro enfoque integra análisis de datos, gestión de riesgos y consideración de impactos a múltiples niveles, asegurando decisiones fundamentadas y alineadas con los objetivos organizacionales.',
    benefits: [
      {
        title: 'Marco metodológico robusto',
        description:
          'Proceso estructurado para análisis y evaluación de alternativas basado en mejores prácticas internacionales',
      },
      {
        title: 'Perspectiva integral',
        description:
          'Consideración holística de impactos financieros, operativos, humanos y estratégicos en cada decisión',
      },
      {
        title: 'Gestión de riesgos avanzada',
        description:
          'Identificación y evaluación sistemática de riesgos potenciales y estrategias de mitigación',
      },
      {
        title: 'Validación objetiva',
        description:
          'Contraste de alternativas contra benchmarks sectoriales y casos de éxito relevantes',
      },
    ],
  },
  'Optimización de procesos de liderazgo': {
    name: 'Optimización de procesos de liderazgo',
    description:
      'Rediseño y mejora de los sistemas de liderazgo organizacional para maximizar su efectividad. Analizamos y refinamos los procesos de comunicación, delegación, gestión de equipos y desarrollo de talento, implementando mejores prácticas adaptadas a la cultura y objetivos específicos de la organización.',
    benefits: [
      {
        title: 'Comunicación efectiva',
        description: 'Mejora de flujos de información ascendentes y descendentes',
      },
      {
        title: 'Empoderamiento de equipos',
        description: 'Sistemas de delegación y autonomía responsable',
      },
      {
        title: 'Gestión del talento',
        description: 'Procesos optimizados para desarrollar futuros líderes',
      },
      {
        title: 'Cultura de alto rendimiento',
        description: 'Alineación de comportamientos con valores y objetivos',
      },
    ],
  },

  'Sesiones one-to-one con enfoque en resultados': {
    name: 'Sesiones one-to-one con enfoque en resultados',
    description:
      'Mentorías personalizadas de alto impacto con consultores ejecutivos experimentados. Estas sesiones individuales se centran en desafíos específicos del directivo, proporcionando orientación práctica, herramientas concretas y seguimiento de resultados para garantizar la aplicación efectiva de los aprendizajes en el contexto real de trabajo.',
    benefits: [
      {
        title: 'Atención personalizada',
        description: 'Enfoque exclusivo en las necesidades del directivo',
      },
      {
        title: 'Confidencialidad total',
        description: 'Espacio seguro para abordar desafíos complejos',
      },
      {
        title: 'Aplicación inmediata',
        description: 'Soluciones prácticas para implementación directa',
      },
      {
        title: 'Seguimiento de impacto',
        description: 'Medición de resultados tangibles tras cada intervención',
      },
    ],
  },

  'Metodologías ágiles y tradicionales (PMBOK, Scrum, Kanban)': {
    name: 'Metodologías ágiles y tradicionales (PMBOK, Scrum, Kanban)',
    description:
      'Implementamos marcos de trabajo híbridos que combinan lo mejor de las metodologías ágiles (Scrum, Kanban) y tradicionales (PMBOK, PRINCE2) para adaptarnos a las necesidades específicas de cada proyecto. Esta aproximación flexible permite maximizar la eficiencia y calidad, equilibrando la estructura y documentación necesarias con la capacidad de respuesta ante cambios. Nuestros directores de proyecto certificados seleccionan y adaptan la metodología más adecuada según la naturaleza del proyecto, los objetivos estratégicos y la cultura organizacional del cliente.',
    benefits: [
      {
        title: 'Adaptabilidad metodológica',
        description: 'Selección personalizada según complejidad, tamaño y cultura organizacional',
      },
      {
        title: 'Gestión de incertidumbre',
        description: 'Capacidad para responder ágilmente a cambios sin perder el control',
      },
      {
        title: 'Documentación equilibrada',
        description: 'Enfoque en documentos de valor real sin burocracia excesiva',
      },
      {
        title: 'Mejora continua',
        description: 'Incorporación de retrospectivas y lecciones aprendidas en tiempo real',
      },
    ],
  },
  'Presentaciones ejecutivas de alto impacto': {
    name: 'Presentaciones ejecutivas de alto impacto',
    description:
      'Desarrollo y entrenamiento en presentaciones profesionales que cautivan a la audiencia y transmiten mensajes clave de forma efectiva.',
    benefits: [
      {
        title: 'Comunicación efectiva',
        description: 'Técnicas probadas para transmitir mensajes complejos',
      },
      {
        title: 'Diseño profesional',
        description: 'Material visual que refuerza el mensaje',
      },
      {
        title: 'Impacto duradero',
        description: 'Presentaciones memorables y persuasivas',
      },
    ],
  },
  'Manuales técnicos y de usuario': {
    name: 'Manuales técnicos y de usuario',
    description:
      'Documentación clara y estructurada que facilita la comprensión y uso de productos o sistemas complejos.',
    benefits: [
      {
        title: 'Claridad técnica',
        description: 'Información precisa y accesible',
      },
      {
        title: 'Estructura optimizada',
        description: 'Organización lógica del contenido',
      },
      {
        title: 'Reducción de consultas',
        description: 'Menor necesidad de soporte técnico',
      },
    ],
  },
  'Soporte técnico': {
    name: 'Soporte técnico',
    description:
      'Proporcionamos asistencia especializada para resolver cualquier incidencia o consulta relacionada con tu plataforma web. Nuestro equipo de expertos está disponible a través de múltiples canales (teléfono, email, chat) para diagnosticar problemas, implementar soluciones y asesorar sobre el uso óptimo de tu sitio. Ofrecemos diferentes niveles de servicio, desde soporte en horario laboral hasta asistencia 24/7 para sitios críticos, garantizando tiempos de respuesta acordes a la severidad de cada incidencia.',
    benefits: [
      {
        title: 'Resolución rápida de incidencias',
        description: 'Tiempos de respuesta garantizados según la severidad del problema',
      },
      {
        title: 'Equipo especializado',
        description: 'Técnicos certificados con amplia experiencia en tecnologías web',
      },
      {
        title: 'Múltiples canales de contacto',
        description: 'Asistencia disponible por teléfono, email, chat y sistema de tickets',
      },
      {
        title: 'Documentación detallada',
        description: 'Registro completo de todas las incidencias y soluciones implementadas',
      },
      {
        title: 'Resolución rápida',
        description: 'Atención inmediata a incidencias técnicas',
      },
      {
        title: 'Soporte multicanal',
        description: 'Asistencia por teléfono, email y chat',
      },
      {
        title: 'Experiencia especializada',
        description: 'Técnicos certificados en diversas tecnologías',
      },
      {
        title: 'Niveles de servicio',
        description: 'SLAs adaptados a la criticidad de tu negocio',
      },
    ],
  },
  'Monitoreo 24/7': {
    name: 'Monitoreo 24/7',
    description:
      'Implementamos sistemas avanzados de monitorización que supervisan tu plataforma web las 24 horas del día, los 7 días de la semana. Mediante herramientas especializadas, vigilamos constantemente la disponibilidad, rendimiento y seguridad de tu sitio, detectando proactivamente cualquier anomalía o problema potencial antes de que afecte a tus usuarios. Nuestros sistemas generan alertas automáticas que permiten a nuestro equipo técnico responder inmediatamente ante cualquier incidencia, minimizando el tiempo de inactividad y garantizando una experiencia óptima para tus visitantes.',
    benefits: [
      {
        title: 'Detección temprana de problemas',
        description: 'Identificación de incidencias antes de que impacten a los usuarios',
      },
      {
        title: 'Tiempo de inactividad minimizado',
        description: 'Respuesta inmediata ante caídas o degradación del servicio',
      },
      {
        title: 'Análisis de tendencias',
        description: 'Identificación de patrones que permiten prevenir problemas futuros',
      },
      {
        title: 'Tranquilidad garantizada',
        description: 'Certeza de que tu sitio está siendo vigilado constantemente',
      },
    ],
  },
  'Actualizaciones de seguridad': {
    name: 'Actualizaciones de seguridad',
    description:
      'Mantenemos tu plataforma web protegida mediante la implementación regular de parches y actualizaciones de seguridad. Nuestro equipo monitoriza constantemente las vulnerabilidades emergentes en CMS, plugins, frameworks y servidores, aplicando las correcciones necesarias de forma proactiva. Realizamos auditorías periódicas de seguridad para identificar posibles puntos débiles y los reforzamos antes de que puedan ser explotados, garantizando la integridad de tu sitio y la protección de los datos de tus usuarios.',
    benefits: [
      {
        title: 'Protección contra vulnerabilidades',
        description: 'Aplicación proactiva de parches de seguridad en cuanto están disponibles',
      },
      {
        title: 'Auditorías periódicas',
        description: 'Revisiones exhaustivas para identificar y corregir posibles puntos débiles',
      },
      {
        title: 'Cumplimiento normativo',
        description: 'Adaptación continua a las regulaciones de protección de datos vigentes',
      },
      {
        title: 'Prevención de intrusiones',
        description: 'Implementación de medidas avanzadas contra ataques maliciosos',
      },
    ],
  },
  'Copias de seguridad': {
    name: 'Copias de seguridad',
    description:
      'Implementamos un sistema robusto de respaldo que garantiza la seguridad de todos los datos de tu plataforma web. Realizamos copias de seguridad automáticas con frecuencia configurable (diaria, semanal o personalizada) tanto de archivos como de bases de datos, almacenándolas en ubicaciones seguras y redundantes. Cada backup es verificado para garantizar su integridad, y mantenemos versiones históricas que permiten recuperar información de diferentes puntos temporales en caso de necesidad.',
    benefits: [
      {
        title: 'Recuperación ante desastres',
        description: 'Capacidad de restaurar completamente el sitio en caso de pérdida de datos',
      },
      {
        title: 'Respaldos automatizados',
        description:
          'Programación de copias sin intervención manual y con verificación de integridad',
      },
      {
        title: 'Almacenamiento redundante',
        description: 'Múltiples ubicaciones de respaldo para eliminar puntos únicos de fallo',
      },
      {
        title: 'Retención configurable',
        description: 'Conservación de versiones históricas según necesidades específicas',
      },
    ],
  },
  'Optimización de rendimiento': {
    name: 'Optimización de rendimiento',
    description:
      'Mejoramos continuamente la velocidad y eficiencia de tu plataforma web mediante técnicas avanzadas de optimización. Implementamos estrategias de caché, compresión de recursos, optimización de bases de datos y minificación de código para reducir los tiempos de carga. Realizamos análisis periódicos de rendimiento utilizando herramientas especializadas para identificar cuellos de botella y aplicar las mejoras necesarias, garantizando una experiencia fluida para tus usuarios incluso en momentos de alto tráfico.',
    benefits: [
      {
        title: 'Tiempos de carga reducidos',
        description: 'Mejora significativa en la velocidad de respuesta de todas las páginas',
      },
      {
        title: 'Mayor retención de usuarios',
        description: 'Reducción de la tasa de rebote gracias a una experiencia más fluida',
      },
      {
        title: 'Escalabilidad mejorada',
        description: 'Capacidad para manejar picos de tráfico sin degradación del servicio',
      },
      {
        title: 'Mejor posicionamiento SEO',
        description: 'Impacto positivo en rankings de búsqueda por la velocidad optimizada',
      },
    ],
  },
  'Estructuración estratégica de propuestas': {
    name: 'Estructuración estratégica de propuestas',
    description:
      'Desarrollo de propuestas comerciales ganadoras con enfoque en diferenciación y valor agregado.',
    benefits: [
      {
        title: 'Enfoque estratégico',
        description: 'Alineación con objetivos del cliente',
      },
      {
        title: 'Argumentación sólida',
        description: 'Propuesta de valor diferenciadora',
      },
      {
        title: 'Presentación profesional',
        description: 'Diseño visual de alto impacto',
      },
    ],
  },

  'Técnicas avanzadas de oratoria': {
    name: 'Técnicas avanzadas de oratoria',
    description:
      'Ofrecemos servicios profesionales de oratoria corporativa con técnicas avanzadas de comunicación, control vocal y lenguaje corporal para potenciar la imagen de su empresa.',
    benefits: [
      {
        title: 'Presentaciones ejecutivas',
        description: 'Discursos de alto impacto para juntas directivas y eventos corporativos',
      },
      {
        title: 'Comunicación técnica',
        description: 'Transmisión efectiva de información compleja y especializada',
      },
      {
        title: 'Representación corporativa',
        description: 'Portavoces profesionales para eventos y conferencias sectoriales',
      },
    ],
  },
  'Diseño de presentaciones efectivas': {
    name: 'Diseño de presentaciones efectivas',
    description:
      'Desarrollamos presentaciones corporativas personalizadas con diseño profesional que refuerzan su identidad de marca y transmiten mensajes complejos de forma clara y atractiva.',
    benefits: [
      {
        title: 'Identidad corporativa',
        description: 'Diseños alineados con su manual de marca y posicionamiento',
      },
      {
        title: 'Visualización de datos',
        description: 'Transformación de información compleja en gráficos comprensibles',
      },
      {
        title: 'Materiales multiplataforma',
        description:
          'Adaptación para presentaciones presenciales, virtuales y documentos descargables',
      },
    ],
  },
  'Manejo de audiencias y escenarios': {
    name: 'Manejo de audiencias y escenarios',
    description:
      'Gestionamos presentaciones corporativas en diversos contextos, adaptando el mensaje según el perfil de la audiencia y las características del evento para maximizar su impacto.',
    benefits: [
      {
        title: 'Eventos sectoriales',
        description: 'Representación en ferias, congresos y conferencias especializadas',
      },
      {
        title: 'Presentaciones a inversores',
        description: 'Comunicación persuasiva de proyectos y resultados financieros',
      },
      {
        title: 'Formatos híbridos',
        description: 'Adaptación a entornos presenciales, virtuales y mixtos',
      },
    ],
  },
  'Storytelling corporativo': {
    name: 'Storytelling corporativo',
    description:
      'Creamos narrativas corporativas memorables que transmiten los valores de su empresa, conectan emocionalmente con sus audiencias clave y refuerzan su posicionamiento en el mercado.',
    benefits: [
      {
        title: 'Historia de marca',
        description: 'Desarrollo de relatos que refuerzan la identidad y valores corporativos',
      },
      {
        title: 'Casos de éxito',
        description: 'Transformación de proyectos técnicos en historias inspiradoras',
      },
      {
        title: 'Comunicación de cambios',
        description:
          'Narrativas para gestionar fusiones, reestructuraciones o nuevas direcciones estratégicas',
      },
    ],
  },
  'Comunicación no verbal': {
    name: 'Comunicación no verbal',
    description:
      'Proporcionamos entrenamiento especializado en lenguaje corporal para sus portavoces corporativos, asegurando que su comunicación no verbal refuerce el mensaje institucional y proyecte profesionalismo.',
    benefits: [
      {
        title: 'Imagen corporativa',
        description: 'Proyección de credibilidad y autoridad en representaciones públicas',
      },
      {
        title: 'Comunicación intercultural',
        description: 'Adaptación de gestos y posturas para audiencias internacionales',
      },
      {
        title: 'Manejo mediático',
        description: 'Preparación para entrevistas y apariciones en medios de comunicación',
      },
    ],
  },
  'Documentación técnica de productos': {
    name: 'Documentación técnica de productos',
    description:
      'Elaboración de documentación detallada y precisa sobre productos, sistemas o servicios técnicos, facilitando su comprensión y uso.',
    benefits: [
      {
        title: 'Precisión técnica',
        description: 'Información exacta y verificada',
      },
      {
        title: 'Claridad expositiva',
        description: 'Explicaciones accesibles de conceptos complejos',
      },
      {
        title: 'Estructura optimizada',
        description: 'Organización lógica y navegable del contenido',
      },
    ],
  },
  'Manuales de usuario y procedimientos': {
    name: 'Manuales de usuario y procedimientos',
    description:
      'Creación de guías paso a paso que facilitan el uso de productos o la ejecución de procesos específicos, reduciendo la curva de aprendizaje.',
    benefits: [
      {
        title: 'Instrucciones claras',
        description: 'Pasos secuenciales fáciles de seguir',
      },
      {
        title: 'Recursos visuales',
        description: 'Imágenes y diagramas explicativos',
      },
      {
        title: 'Resolución de problemas',
        description: 'Secciones de troubleshooting y preguntas frecuentes',
      },
    ],
  },
  'White papers y casos de estudio': {
    name: 'White papers y casos de estudio',
    description:
      'Desarrollo de documentos técnicos y casos de éxito que demuestran expertise, solucionan problemas complejos y posicionan a la empresa como referente en su sector.',
    benefits: [
      {
        title: 'Autoridad sectorial',
        description: 'Posicionamiento como experto en la industria',
      },
      {
        title: 'Generación de leads',
        description: 'Captación de prospectos cualificados',
      },
      {
        title: 'Evidencia tangible',
        description: 'Demostración de resultados y capacidades',
      },
    ],
  },
  'Informes técnicos y de investigación': {
    name: 'Informes técnicos y de investigación',
    description:
      'Elaboración de reportes detallados sobre investigaciones, análisis o evaluaciones técnicas con rigor metodológico y conclusiones fundamentadas.',
    benefits: [
      {
        title: 'Rigor analítico',
        description: 'Metodología sólida y verificable',
      },
      {
        title: 'Visualización de datos',
        description: 'Gráficos y tablas interpretativas',
      },
      {
        title: 'Recomendaciones accionables',
        description: 'Conclusiones prácticas basadas en evidencia',
      },
    ],
  },
  'Optimización SEO de contenidos técnicos': {
    name: 'Optimización SEO de contenidos técnicos',
    description:
      'Adaptación de contenidos técnicos para mejorar su visibilidad en buscadores sin sacrificar precisión ni calidad, aumentando el tráfico cualificado.',
    benefits: [
      {
        title: 'Visibilidad sectorial',
        description: 'Posicionamiento en búsquedas especializadas',
      },
      {
        title: 'Equilibrio técnico-SEO',
        description: 'Contenido optimizado sin perder rigor',
      },
      {
        title: 'Estructura semántica',
        description: 'Organización de contenido favorable para buscadores',
      },
    ],
  },
  'SEO técnico avanzado': {
    name: 'SEO técnico avanzado',
    description:
      'Implementamos optimizaciones técnicas avanzadas que mejoran el rendimiento y la visibilidad de tu sitio web en los motores de búsqueda. Mediante auditorías exhaustivas, identificamos y corregimos problemas estructurales, optimizamos la velocidad de carga, mejoramos la arquitectura de información y aseguramos la correcta indexación de contenidos, estableciendo una base sólida para el posicionamiento orgánico.',
    benefits: [
      {
        title: 'Rendimiento optimizado',
        description: 'Mejora de velocidad de carga y experiencia de usuario',
      },
      {
        title: 'Indexación eficiente',
        description: 'Estructura técnica que facilita el rastreo por buscadores',
      },
      {
        title: 'Compatibilidad móvil',
        description: 'Adaptación perfecta a los estándares de mobile-first indexing',
      },
      {
        title: 'Datos estructurados',
        description: 'Implementación de schema markup para resultados enriquecidos',
      },
    ],
  },
  'Estrategia de contenidos': {
    name: 'Estrategia de contenidos',
    description:
      'Desarrollamos planes integrales de contenido orientados a posicionamiento y conversión. Mediante investigación de palabras clave, análisis de intención de búsqueda y estudio de competencia, creamos calendarios editoriales y pautas de contenido que atraen tráfico cualificado y responden exactamente a las necesidades informativas de tu audiencia, generando autoridad temática y oportunidades de conversión.',
    benefits: [
      {
        title: 'Relevancia temática',
        description: 'Contenido alineado con intenciones de búsqueda específicas',
      },
      {
        title: 'Consistencia editorial',
        description: 'Publicación planificada que construye autoridad progresivamente',
      },
      {
        title: 'Optimización semántica',
        description: 'Cobertura completa de temas relacionados y términos asociados',
      },
      {
        title: 'Contenido convertidor',
        description: 'Textos estratégicamente diseñados para guiar hacia la acción',
      },
    ],
  },
  'Campañas publicitarias': {
    name: 'Campañas publicitarias',
    description:
      'Diseñamos, implementamos y optimizamos campañas publicitarias digitales de alto rendimiento en múltiples plataformas (Google Ads, Meta Ads, LinkedIn). Desarrollamos estrategias personalizadas con segmentación avanzada, creatividades de impacto y estructuras de cuenta optimizadas para maximizar el retorno de inversión, captar audiencias cualificadas y acelerar la consecución de objetivos comerciales.',
    benefits: [
      {
        title: 'Segmentación precisa',
        description: 'Alcance específico a audiencias con alta probabilidad de conversión',
      },
      {
        title: 'Optimización continua',
        description: 'Ajustes basados en datos para mejorar rendimiento progresivamente',
      },
      {
        title: 'Escalabilidad controlada',
        description: 'Expansión estratégica de campañas manteniendo eficiencia',
      },
      {
        title: 'Atribución avanzada',
        description: 'Identificación precisa del impacto de cada canal y formato',
      },
    ],
  },
  'Análisis de competencia': {
    name: 'Análisis de competencia',
    description:
      'Realizamos estudios exhaustivos del ecosistema digital de tus competidores para identificar oportunidades estratégicas. Analizamos su posicionamiento orgánico, estrategias de contenido, tácticas publicitarias y presencia en redes sociales, proporcionándote insights accionables para superar a la competencia y destacar en tu sector con enfoques diferenciados.',
    benefits: [
      {
        title: 'Benchmarking sectorial',
        description: 'Comparativa detallada con los referentes de tu industria',
      },
      {
        title: 'Detección de nichos',
        description: 'Identificación de oportunidades desatendidas por competidores',
      },
      {
        title: 'Análisis de fortalezas',
        description: 'Comprensión de factores diferenciales de la competencia',
      },
      {
        title: 'Estrategia diferenciadora',
        description: 'Desarrollo de propuestas únicas basadas en gaps competitivos',
      },
    ],
  },
  'Reportes de rendimiento': {
    name: 'Reportes de rendimiento',
    description:
      'Desarrollamos informes personalizados que transforman datos complejos en insights accionables sobre el rendimiento de tus estrategias digitales. Mediante dashboards interactivos y análisis periódicos, monitorizamos KPIs clave, identificamos tendencias, evaluamos el ROI de cada acción y proporcionamos recomendaciones estratégicas basadas en datos para optimizar continuamente los resultados.',
    benefits: [
      {
        title: 'Visualización intuitiva',
        description: 'Presentación clara de métricas complejas mediante gráficos personalizados',
      },
      {
        title: 'Análisis multidimensional',
        description: 'Correlación de datos de diferentes fuentes y canales',
      },
      {
        title: 'Seguimiento de objetivos',
        description: 'Monitorización continua del progreso hacia metas establecidas',
      },
      {
        title: 'Recomendaciones prácticas',
        description: 'Sugerencias concretas basadas en el análisis de datos',
      },
    ],
  },
  'Análisis de necesidades del cliente': {
    name: 'Análisis de necesidades del cliente',
    description:
      'Estudio detallado de los requerimientos, desafíos y objetivos del cliente para desarrollar propuestas comerciales perfectamente alineadas con sus necesidades reales.',
    benefits: [
      {
        title: 'Comprensión profunda',
        description: 'Identificación de necesidades explícitas e implícitas',
      },
      {
        title: 'Personalización efectiva',
        description: 'Adaptación precisa de soluciones',
      },
      {
        title: 'Anticipación',
        description: 'Previsión de objeciones y requerimientos futuros',
      },
    ],
  },
  'Estructuración de propuestas ganadoras': {
    name: 'Estructuración de propuestas ganadoras',
    description:
      'Diseño estratégico de propuestas comerciales con estructura clara, argumentación sólida y enfoque en el valor diferencial para maximizar la tasa de conversión.',
    benefits: [
      {
        title: 'Arquitectura persuasiva',
        description: 'Estructura lógica y progresiva del argumento',
      },
      {
        title: 'Diferenciación competitiva',
        description: 'Énfasis en ventajas únicas y valor agregado',
      },
      {
        title: 'Claridad en condiciones',
        description: 'Términos y alcance perfectamente definidos',
      },
    ],
  },
  'Diseño visual profesional': {
    name: 'Diseño visual profesional',
    description:
      'Creación de materiales visuales de alta calidad que refuerzan el mensaje de la propuesta y proyectan profesionalismo, aumentando la percepción de valor de la oferta.',
    benefits: [
      {
        title: 'Identidad consistente',
        description: 'Alineación con la imagen corporativa',
      },
      {
        title: 'Jerarquía visual',
        description: 'Organización que guía la lectura y comprensión',
      },
      {
        title: 'Recursos gráficos',
        description: 'Diagramas, infografías y visualizaciones de datos',
      },
    ],
  },
  'Argumentación comercial efectiva': {
    name: 'Argumentación comercial efectiva',
    description:
      'Desarrollo de argumentos de venta sólidos basados en beneficios, evidencias y retorno de inversión, estructurados para superar objeciones y facilitar la decisión de compra.',
    benefits: [
      {
        title: 'Enfoque en beneficios',
        description: 'Traducción de características en valor para el cliente',
      },
      {
        title: 'Evidencia demostrativa',
        description: 'Casos de éxito y testimoniales relevantes',
      },
      {
        title: 'Manejo de objeciones',
        description: 'Anticipación y respuesta a posibles resistencias',
      },
    ],
  },
  'Seguimiento y optimización de propuestas': {
    name: 'Seguimiento y optimización de propuestas',
    description:
      'Sistema de seguimiento y refinamiento continuo de propuestas comerciales basado en feedback y resultados, mejorando progresivamente las tasas de conversión.',
    benefits: [
      {
        title: 'Análisis de resultados',
        description: 'Evaluación sistemática de tasas de éxito',
      },
      {
        title: 'Iteración estratégica',
        description: 'Mejora continua basada en datos',
      },
      {
        title: 'Personalización incremental',
        description: 'Ajuste progresivo a preferencias del mercado',
      },
    ],
  },
  'Automatización de tareas': {
    name: 'Automatización de tareas',
    description:
      'Implementamos soluciones que automatizan procesos repetitivos y manuales, liberando a tu equipo para enfocarse en actividades de mayor valor. Utilizamos herramientas como Power Automate, Zapier o desarrollos a medida para crear flujos de trabajo automatizados que ejecutan tareas rutinarias sin intervención humana.',
    benefits: [
      {
        title: 'Reducción de errores',
        description: 'Eliminación de errores humanos en procesos repetitivos',
      },
      {
        title: 'Ahorro de tiempo',
        description: 'Liberación de horas-hombre para tareas estratégicas',
      },
      {
        title: 'Consistencia operativa',
        description: 'Ejecución estandarizada de procesos clave',
      },
    ],
  },
  'Integración de sistemas': {
    name: 'Integración de sistemas',
    description:
      'Conectamos tus diferentes plataformas y aplicaciones para que trabajen como un ecosistema unificado. Desarrollamos integraciones mediante APIs, webhooks o middleware que permiten el flujo automático de información entre sistemas, eliminando silos de datos y duplicidad de trabajo.',
    benefits: [
      {
        title: 'Flujo de datos continuo',
        description: 'Transferencia automática de información entre plataformas',
      },
      {
        title: 'Eliminación de redundancias',
        description: 'Fin de la doble entrada de datos en múltiples sistemas',
      },
      {
        title: 'Visión unificada',
        description: 'Consolidación de datos para análisis integral',
      },
    ],
  },
  'Reportes automáticos': {
    name: 'Reportes automáticos',
    description:
      'Implementamos sistemas que generan y distribuyen informes periódicos sin intervención manual. Configuramos la extracción, procesamiento y presentación automática de datos clave, asegurando que la información crítica llegue a los responsables de decisiones en el momento oportuno.',
    benefits: [
      {
        title: 'Puntualidad informativa',
        description: 'Entrega consistente de información en fechas programadas',
      },
      {
        title: 'Personalización de contenido',
        description: 'Adaptación de informes según necesidades de cada área',
      },
      {
        title: 'Trazabilidad histórica',
        description: 'Acceso a reportes anteriores para análisis comparativo',
      },
    ],
  },
  'Flujos de trabajo': {
    name: 'Flujos de trabajo',
    description:
      'Diseñamos e implementamos workflows digitales que optimizan la secuencia de actividades en procesos complejos. Mediante la definición clara de pasos, responsables y condiciones, creamos flujos que guían las tareas desde su inicio hasta su finalización, asegurando cumplimiento y eficiencia.',
    benefits: [
      {
        title: 'Claridad procesal',
        description: 'Definición explícita de responsabilidades y pasos a seguir',
      },
      {
        title: 'Seguimiento en tiempo real',
        description: 'Visibilidad del estado actual de cada proceso',
      },
      {
        title: 'Escalabilidad operativa',
        description: 'Capacidad para manejar mayor volumen sin incrementar personal',
      },
    ],
  },
  'Modelos predictivos personalizados': {
    name: 'Modelos predictivos personalizados',
    description:
      'Desarrollamos algoritmos de machine learning adaptados a tus datos y objetivos específicos. Estos modelos analizan patrones históricos para predecir comportamientos futuros, identificar tendencias emergentes y anticipar cambios en variables clave para tu negocio.',
    benefits: [
      {
        title: 'Anticipación estratégica',
        description: 'Previsión de cambios en el mercado o comportamiento de clientes',
      },
      {
        title: 'Precisión incremental',
        description: 'Mejora continua del modelo con nuevos datos',
      },
      {
        title: 'Adaptabilidad sectorial',
        description: 'Algoritmos específicos para tu industria y caso de uso',
      },
    ],
  },
  'Análisis de tendencias en tiempo real': {
    name: 'Análisis de tendencias en tiempo real',
    description:
      'Implementamos sistemas de monitoreo continuo que procesan datos en tiempo real para identificar patrones, anomalías y oportunidades. Estas soluciones permiten reaccionar inmediatamente ante cambios significativos en métricas clave, sin esperar a reportes periódicos.',
    benefits: [
      {
        title: 'Reacción inmediata',
        description: 'Capacidad de respuesta ante cambios súbitos',
      },
      {
        title: 'Detección de anomalías',
        description: 'Identificación temprana de desviaciones significativas',
      },
      {
        title: 'Optimización continua',
        description: 'Ajustes incrementales basados en datos actualizados',
      },
    ],
  },
  'Integración con fuentes de datos existentes': {
    name: 'Integración con fuentes de datos existentes',
    description:
      'Conectamos tu solución predictiva con las fuentes de datos que ya utilizas en tu organización, desde bases de datos relacionales y data warehouses hasta APIs externas y sistemas legacy. Implementamos procesos ETL (Extracción, Transformación y Carga) eficientes que garantizan la consistencia y actualización de la información.',
    benefits: [
      {
        title: 'Aprovechamiento de activos existentes',
        description: 'Maximización del valor de tus inversiones previas en datos',
      },
      {
        title: 'Implementación no disruptiva',
        description: 'Integración sin alterar los sistemas operativos actuales',
      },
      {
        title: 'Visión unificada',
        description: 'Consolidación de datos dispersos en una única plataforma analítica',
      },
    ],
  },
  'Alertas predictivas automatizadas': {
    name: 'Alertas predictivas automatizadas',
    description:
      'Desarrollamos sistemas de alertas inteligentes que notifican proactivamente sobre eventos futuros probables, basados en patrones detectados por nuestros modelos predictivos. Estas alertas pueden configurarse según umbrales personalizados y distribuirse a través de múltiples canales (email, SMS, notificaciones push, integraciones con sistemas de tickets).',
    benefits: [
      {
        title: 'Anticipación a problemas',
        description: 'Detección temprana de situaciones críticas antes de que ocurran',
      },
      {
        title: 'Reducción de falsos positivos',
        description: 'Algoritmos refinados que minimizan alertas innecesarias',
      },
      {
        title: 'Personalización por roles',
        description: 'Distribución selectiva según responsabilidades y niveles de decisión',
      },
    ],
  },
  'Dashboards interactivos': {
    name: 'Dashboards interactivos',
    description:
      'Creamos paneles de control dinámicos y personalizables que presentan los resultados de los análisis predictivos de forma visual e intuitiva. Estos dashboards permiten la exploración interactiva de datos, filtrado contextual y drill-down para profundizar en los detalles relevantes para cada decisión.',
    benefits: [
      {
        title: 'Visualización intuitiva',
        description: 'Representación gráfica que facilita la comprensión de datos complejos',
      },
      {
        title: 'Accesibilidad multiplataforma',
        description: 'Disponibilidad en dispositivos móviles y escritorio',
      },
      {
        title: 'Personalización por usuario',
        description: 'Configuración de vistas según necesidades específicas de cada rol',
      },
    ],
  },

  'Auditoría de procesos administrativos': {
    name: 'Auditoría de procesos administrativos',
    description:
      'Realizamos un análisis exhaustivo de los procesos administrativos actuales de tu organización para identificar ineficiencias, redundancias y áreas de mejora. Utilizamos metodologías probadas como Lean, Six Sigma y BPM (Business Process Management) para documentar, analizar y evaluar cada proceso, generando recomendaciones específicas que optimizan recursos y mejoran la productividad.',
    benefits: [
      {
        title: 'Diagnóstico integral',
        description: 'Identificación de cuellos de botella y oportunidades de mejora',
      },
      {
        title: 'Documentación estandarizada',
        description: 'Mapeo detallado de procesos actuales y propuestos',
      },
      {
        title: 'Optimización de recursos',
        description: 'Reducción de tiempos y costos operativos',
      },
      {
        title: 'Cumplimiento normativo',
        description: 'Alineación con regulaciones y mejores prácticas del sector',
      },
    ],
  },

  'Diseño e implementación de flujos de trabajo optimizados': {
    name: 'Diseño e implementación de flujos de trabajo optimizados',
    description:
      'Desarrollamos e implementamos flujos de trabajo eficientes que automatizan y optimizan las operaciones administrativas. Mediante el análisis de las necesidades específicas de tu organización, diseñamos procesos que eliminan tareas redundantes, reducen errores manuales y aceleran los tiempos de ejecución, permitiendo a tu equipo enfocarse en actividades de mayor valor estratégico.',
    benefits: [
      {
        title: 'Automatización inteligente',
        description: 'Eliminación de tareas manuales repetitivas',
      },
      {
        title: 'Trazabilidad completa',
        description: 'Seguimiento en tiempo real del estado de cada proceso',
      },
      {
        title: 'Escalabilidad',
        description: 'Adaptación flexible a volúmenes crecientes de trabajo',
      },
      {
        title: 'Integración tecnológica',
        description: 'Conexión con sistemas existentes y nuevas herramientas',
      },
    ],
  },

  'Digitalización de documentación y archivos': {
    name: 'Digitalización de documentación y archivos',
    description:
      'Transformamos tu documentación física en activos digitales accesibles, seguros y fácilmente recuperables. Implementamos soluciones de digitalización que incluyen escaneo de alta calidad, reconocimiento óptico de caracteres (OCR), indexación inteligente y almacenamiento estructurado, facilitando la búsqueda y recuperación inmediata de información crítica para tu negocio.',
    benefits: [
      {
        title: 'Accesibilidad inmediata',
        description: 'Recuperación instantánea de documentos desde cualquier ubicación',
      },
      {
        title: 'Seguridad avanzada',
        description: 'Protección de información sensible con controles de acceso',
      },
      {
        title: 'Ahorro de espacio físico',
        description: 'Eliminación de archivadores y almacenamiento físico',
      },
      {
        title: 'Sostenibilidad',
        description: 'Reducción del consumo de papel y huella ambiental',
      },
    ],
  },

  'Implementación de sistemas de gestión documental': {
    name: 'Implementación de sistemas de gestión documental',
    description:
      'Diseñamos e implementamos sistemas integrales de gestión documental (DMS) adaptados a las necesidades específicas de tu organización. Estas soluciones permiten la creación, captura, clasificación, almacenamiento, recuperación y disposición controlada de documentos, optimizando el ciclo de vida completo de la información empresarial y garantizando el cumplimiento normativo.',
    benefits: [
      {
        title: 'Centralización de información',
        description: 'Repositorio único para toda la documentación corporativa',
      },
      {
        title: 'Flujos de aprobación',
        description: 'Automatización de procesos de revisión y autorización',
      },
      {
        title: 'Versionado y auditoría',
        description: 'Control de cambios y registro detallado de acciones',
      },
      {
        title: 'Cumplimiento regulatorio',
        description: 'Adaptación a normativas de conservación y protección de datos',
      },
    ],
  },

  'Planificación estratégica y definición de alcance': {
    name: 'Planificación estratégica y definición de alcance',
    description:
      'Desarrollamos planes de proyecto exhaustivos y precisos que establecen claramente los objetivos, entregables, cronogramas y límites del proyecto. Mediante técnicas avanzadas de planificación estratégica, definimos un alcance realista y medible que se alinea con los objetivos de negocio, identificando dependencias críticas, riesgos potenciales y estableciendo mecanismos de control de cambios para gestionar eficazmente las modificaciones durante la ejecución.',
    benefits: [
      {
        title: 'Alineación estratégica',
        description: 'Vinculación directa entre objetivos del proyecto y metas organizacionales',
      },
      {
        title: 'Claridad de expectativas',
        description: 'Definición precisa de entregables y criterios de aceptación',
      },
      {
        title: 'Gestión proactiva de riesgos',
        description: 'Identificación temprana de amenazas y oportunidades',
      },
      {
        title: 'Control de cambios estructurado',
        description: 'Proceso formal para evaluar y aprobar modificaciones al alcance',
      },
    ],
  },

  'Capacitación de personal administrativo': {
    name: 'Capacitación de personal administrativo',
    description:
      'Desarrollamos programas de formación personalizados para potenciar las habilidades y conocimientos de tu equipo administrativo. Nuestros entrenamientos combinan teoría y práctica, enfocándose en el dominio de nuevas herramientas, metodologías de trabajo y mejores prácticas que incrementan la productividad y calidad del trabajo administrativo.',
    benefits: [
      {
        title: 'Desarrollo de competencias',
        description: 'Fortalecimiento de habilidades técnicas y blandas',
      },
      {
        title: 'Adaptación al cambio',
        description: 'Preparación para nuevos procesos y tecnologías',
      },
      {
        title: 'Estandarización de prácticas',
        description: 'Homogeneización de procedimientos y criterios',
      },
      {
        title: 'Empoderamiento del equipo',
        description: 'Mayor autonomía y capacidad de resolución de problemas',
      },
    ],
  },

  'Gestión de recursos y presupuestos': {
    name: 'Gestión de recursos y presupuestos',
    description:
      'Implementamos sistemas eficientes para la planificación, asignación y control de recursos humanos, materiales y financieros del proyecto. Utilizamos herramientas especializadas para desarrollar presupuestos detallados, establecer líneas base de costos, optimizar la asignación de recursos según habilidades y disponibilidad, y realizar un seguimiento riguroso de gastos con análisis de valor ganado (EVM) para detectar y corregir desviaciones presupuestarias de forma temprana.',
    benefits: [
      {
        title: 'Optimización de recursos',
        description: 'Asignación eficiente basada en capacidades y prioridades del proyecto',
      },
      {
        title: 'Control presupuestario',
        description: 'Monitoreo continuo de gastos vs. presupuesto con alertas tempranas',
      },
      {
        title: 'Análisis de valor ganado',
        description: 'Evaluación objetiva del progreso financiero y técnico del proyecto',
      },
      {
        title: 'Transparencia financiera',
        description: 'Reportes claros y detallados del estado financiero del proyecto',
      },
    ],
  },

  'Control y seguimiento de hitos y entregables': {
    name: 'Control y seguimiento de hitos y entregables',
    description:
      'Establecemos un sistema integral de monitoreo y control para supervisar el avance del proyecto contra la planificación establecida. Implementamos dashboards personalizados que visualizan el progreso en tiempo real, utilizamos metodologías de seguimiento estructuradas para verificar el cumplimiento de hitos clave, y aplicamos procesos rigurosos de control de calidad para asegurar que cada entregable cumpla con los estándares definidos antes de su aceptación formal.',
    benefits: [
      {
        title: 'Visibilidad en tiempo real',
        description: 'Dashboards actualizados con indicadores clave de desempeño (KPIs)',
      },
      {
        title: 'Detección temprana de desviaciones',
        description: 'Identificación proactiva de retrasos o problemas potenciales',
      },
      {
        title: 'Aseguramiento de calidad',
        description: 'Verificación sistemática del cumplimiento de requisitos y estándares',
      },
      {
        title: 'Comunicación efectiva',
        description: 'Reportes de estado claros y concisos para todos los interesados',
      },
    ],
  },

  'Evaluación de resultados y mejora continua': {
    name: 'Evaluación de resultados y mejora continua',
    description:
      'Implementamos un enfoque sistemático para evaluar el desempeño del proyecto y capturar lecciones aprendidas que impulsen la mejora continua. Realizamos análisis post-implementación para medir el cumplimiento de objetivos, conducimos sesiones estructuradas de retrospectiva con todos los involucrados, documentamos buenas prácticas y áreas de mejora, y desarrollamos planes de acción concretos para optimizar la gestión de futuros proyectos y maximizar el valor entregado a la organización.',
    benefits: [
      {
        title: 'Aprendizaje organizacional',
        description: 'Capitalización de experiencias para mejorar proyectos futuros',
      },
      {
        title: 'Medición de impacto',
        description: 'Evaluación objetiva del valor generado para el negocio',
      },
      {
        title: 'Cultura de excelencia',
        description: 'Fomento de la mejora continua y la innovación en la gestión de proyectos',
      },
      {
        title: 'Transferencia de conocimiento',
        description: 'Documentación estructurada de mejores prácticas y lecciones aprendidas',
      },
    ],
  },

  'Gestión de inventario': {
    name: 'Gestión de inventario',
    description:
      'Implementamos sistemas avanzados de gestión de inventario que automatizan y optimizan todo el ciclo de vida de tus productos. Desde la recepción y almacenamiento hasta el picking, packing y despacho, nuestras soluciones proporcionan visibilidad en tiempo real, trazabilidad completa y control preciso de existencias, minimizando errores, reduciendo costos operativos y mejorando la satisfacción del cliente.',
    benefits: [
      {
        title: 'Control en tiempo real',
        description: 'Monitoreo continuo de niveles de stock y ubicaciones',
      },
      {
        title: 'Optimización de almacenamiento',
        description: 'Distribución eficiente basada en rotación y características de productos',
      },
      {
        title: 'Reducción de obsolescencia',
        description: 'Alertas automáticas para productos próximos a vencer o con baja rotación',
      },
      {
        title: 'Planificación predictiva',
        description: 'Forecasting de demanda basado en históricos y tendencias',
      },
    ],
  },

  'Contabilidad integrada': {
    name: 'Contabilidad integrada',
    description:
      'Desarrollamos soluciones contables completamente integradas con todos los módulos operativos de tu empresa. Nuestros sistemas automatizan el registro de transacciones, generan asientos contables en tiempo real, facilitan el cumplimiento tributario y proporcionan reportes financieros precisos y actualizados, permitiéndote tomar decisiones estratégicas basadas en información financiera confiable y oportuna.',
    benefits: [
      {
        title: 'Automatización contable',
        description: 'Registro automático de transacciones desde todos los departamentos',
      },
      {
        title: 'Cumplimiento normativo',
        description: 'Adaptación a regulaciones fiscales locales e internacionales',
      },
      {
        title: 'Reportería financiera avanzada',
        description: 'Estados financieros, flujos de caja y análisis de rentabilidad',
      },
      {
        title: 'Conciliación bancaria',
        description: 'Proceso simplificado y automatizado de conciliación',
      },
    ],
  },

  CRM: {
    name: 'CRM',
    description:
      'Implementamos sistemas de gestión de relaciones con clientes que centralizan toda la información de tus contactos comerciales. Nuestras soluciones CRM permiten seguimiento detallado del ciclo de ventas, gestión de oportunidades, automatización de marketing, servicio post-venta y análisis de comportamiento del cliente, mejorando la retención, maximizando el valor del ciclo de vida y optimizando la experiencia del cliente en todos los puntos de contacto.',
    benefits: [
      {
        title: 'Visión 360° del cliente',
        description: 'Historial completo de interacciones, compras y preferencias',
      },
      {
        title: 'Automatización de ventas',
        description: 'Seguimiento de leads, oportunidades y pipeline comercial',
      },
      {
        title: 'Segmentación avanzada',
        description: 'Clasificación de clientes según valor, comportamiento y potencial',
      },
      {
        title: 'Personalización de comunicaciones',
        description: 'Mensajes adaptados a las necesidades específicas de cada cliente',
      },
    ],
  },

  'Reportes avanzados': {
    name: 'Reportes avanzados',
    description:
      'Desarrollamos sistemas de reportería avanzada que transforman datos complejos en información accionable. Mediante dashboards interactivos, informes personalizados y análisis multidimensional, nuestras soluciones permiten visualizar tendencias, identificar anomalías y descubrir oportunidades ocultas en tus datos operativos, facilitando la toma de decisiones estratégicas basadas en evidencia y no en intuición.',
    benefits: [
      {
        title: 'Visualización interactiva',
        description: 'Dashboards dinámicos con filtros y drill-down contextual',
      },
      {
        title: 'Automatización de informes',
        description: 'Generación y distribución programada según roles y necesidades',
      },
      {
        title: 'Análisis multidimensional',
        description: 'Exploración de datos desde múltiples perspectivas y variables',
      },
      {
        title: 'Alertas inteligentes',
        description: 'Notificaciones automáticas ante desviaciones significativas',
      },
    ],
  },

  'Facturación electrónica': {
    name: 'Facturación electrónica',
    description:
      'Implementamos soluciones de facturación electrónica que cumplen con todas las normativas fiscales vigentes. Nuestros sistemas automatizan la emisión, validación, timbrado y envío de comprobantes fiscales digitales, garantizando su validez legal, facilitando el cumplimiento tributario y optimizando el proceso de cobranza mediante la integración con pasarelas de pago y sistemas de gestión financiera.',
    benefits: [
      {
        title: 'Cumplimiento normativo',
        description: 'Adaptación automática a cambios en regulaciones fiscales',
      },
      {
        title: 'Reducción de errores',
        description: 'Validación automática de datos fiscales y cálculos',
      },
      {
        title: 'Optimización de cobranza',
        description: 'Integración con múltiples métodos de pago y recordatorios automáticos',
      },
      {
        title: 'Archivo digital',
        description: 'Almacenamiento seguro y recuperación eficiente de documentos fiscales',
      },
    ],
  },

  RPA: {
    name: 'RPA',
    description:
      'Implementamos Robotic Process Automation (RPA) para automatizar tareas repetitivas y basadas en reglas que anteriormente requerían intervención humana. Nuestras soluciones RPA identifican procesos candidatos a automatización, desarrollan robots virtuales personalizados y los integran con tus sistemas existentes, liberando a tu equipo para enfocarse en actividades de mayor valor estratégico mientras reducen errores y aceleran la ejecución de procesos.',
    benefits: [
      {
        title: 'Reducción de costos operativos',
        description: 'Disminución significativa en horas-hombre dedicadas a tareas rutinarias',
      },
      {
        title: 'Precisión y consistencia',
        description: 'Eliminación de errores humanos en procesos críticos',
      },
      {
        title: 'Escalabilidad inmediata',
        description: 'Capacidad para gestionar picos de demanda sin recursos adicionales',
      },
      {
        title: 'Integración no invasiva',
        description: 'Funcionamiento sobre interfaces existentes sin modificar sistemas core',
      },
    ],
  },

  'Workflows complejos': {
    name: 'Workflows complejos',
    description:
      'Diseñamos e implementamos flujos de trabajo automatizados para procesos empresariales complejos que involucran múltiples departamentos, sistemas y reglas de negocio. Mediante tecnologías de BPM (Business Process Management) y orquestación de servicios, modelamos, automatizamos y optimizamos tus procesos críticos, incorporando lógica condicional, aprobaciones multinivel, gestión de excepciones y monitoreo en tiempo real para maximizar la eficiencia operativa.',
    benefits: [
      {
        title: 'Estandarización de procesos',
        description: 'Garantía de cumplimiento de procedimientos establecidos',
      },
      {
        title: 'Visibilidad completa',
        description: 'Transparencia en el estado y progreso de cada instancia del proceso',
      },
      {
        title: 'Adaptabilidad dinámica',
        description: 'Modificación ágil de flujos ante cambios en requerimientos de negocio',
      },
      {
        title: 'Gobierno y cumplimiento',
        description: 'Trazabilidad completa para auditorías y control interno',
      },
    ],
  },

  'Integración IoT': {
    name: 'Integración IoT',
    description:
      'Desarrollamos soluciones que conectan dispositivos físicos con tus sistemas empresariales para capturar, procesar y analizar datos del mundo real en tiempo real. Implementamos arquitecturas IoT completas que incluyen selección e instalación de sensores, configuración de gateways, desarrollo de plataformas de gestión de dispositivos y creación de aplicaciones para visualización y control, permitiéndote tomar decisiones basadas en información actualizada del entorno operativo.',
    benefits: [
      {
        title: 'Monitoreo continuo',
        description: 'Supervisión 24/7 de activos, instalaciones y condiciones ambientales',
      },
      {
        title: 'Mantenimiento predictivo',
        description: 'Anticipación a fallos mediante análisis de patrones de comportamiento',
      },
      {
        title: 'Optimización de recursos',
        description: 'Ajuste dinámico de consumo energético y utilización de activos',
      },
      {
        title: 'Nuevos modelos de negocio',
        description: 'Habilitación de servicios basados en datos y resultados',
      },
    ],
  },

  'Monitoreo en tiempo real': {
    name: 'Monitoreo en tiempo real',
    description:
      'Implementamos sistemas avanzados de monitoreo que proporcionan visibilidad instantánea sobre el estado y rendimiento de tus operaciones críticas. Mediante dashboards personalizados, alertas inteligentes y análisis de tendencias, nuestras soluciones detectan proactivamente anomalías, predicen problemas potenciales y facilitan respuestas inmediatas, minimizando tiempos de inactividad y optimizando la eficiencia operativa en entornos complejos.',
    benefits: [
      {
        title: 'Detección temprana de incidentes',
        description: 'Identificación de problemas antes que afecten al negocio',
      },
      {
        title: 'Respuesta proactiva',
        description: 'Activación automática de protocolos ante eventos críticos',
      },
      {
        title: 'Análisis de causa raíz',
        description: 'Diagnóstico preciso mediante correlación de eventos y métricas',
      },
      {
        title: 'Optimización continua',
        description: 'Ajuste de parámetros operativos basado en datos históricos y en tiempo real',
      },
    ],
  },

  'Dashboards personalizados': {
    name: 'Dashboards personalizados',
    description:
      'Diseñamos e implementamos paneles de control interactivos adaptados a las necesidades específicas de cada rol y nivel organizacional. Nuestros dashboards transforman datos complejos en visualizaciones intuitivas que comunican eficazmente información crítica, tendencias y KPIs, permitiendo a los usuarios identificar oportunidades, detectar problemas y tomar decisiones informadas mediante una experiencia visual optimizada para diferentes dispositivos y contextos de uso.',
    benefits: [
      {
        title: 'Personalización por rol',
        description: 'Información relevante según responsabilidades y objetivos específicos',
      },
      {
        title: 'Visualización intuitiva',
        description: 'Representación gráfica que facilita la comprensión de datos complejos',
      },
      {
        title: 'Interactividad avanzada',
        description: 'Filtros dinámicos, drill-down y análisis ad-hoc',
      },
      {
        title: 'Accesibilidad multiplataforma',
        description: 'Experiencia optimizada en dispositivos móviles, tablets y pantallas',
      },
    ],
  },

  'Análisis predictivo': {
    name: 'Análisis predictivo',
    description:
      'Implementamos soluciones avanzadas de analítica que utilizan algoritmos de machine learning para identificar patrones en datos históricos y predecir comportamientos o resultados futuros. Nuestros modelos predictivos analizan múltiples variables para anticipar tendencias de mercado, comportamiento de clientes, necesidades de mantenimiento o riesgos operativos, proporcionando insights accionables que permiten pasar de una gestión reactiva a una estrategia proactiva basada en datos.',
    benefits: [
      {
        title: 'Anticipación a cambios',
        description: 'Identificación temprana de tendencias y oportunidades de mercado',
      },
      {
        title: 'Optimización de inventarios',
        description: 'Previsión precisa de demanda para reducir costos de almacenamiento',
      },
      {
        title: 'Prevención de pérdidas',
        description: 'Detección anticipada de fraudes, fugas o comportamientos anómalos',
      },
      {
        title: 'Personalización a escala',
        description: 'Recomendaciones individualizadas basadas en patrones de comportamiento',
      },
    ],
  },

  'KPIs en tiempo real': {
    name: 'KPIs en tiempo real',
    description:
      'Desarrollamos sistemas de indicadores clave de desempeño que capturan, procesan y visualizan métricas críticas de negocio en tiempo real. Nuestras soluciones conectan múltiples fuentes de datos, calculan automáticamente KPIs personalizados y los presentan en interfaces intuitivas con umbrales, alertas y comparativas históricas, permitiendo a los equipos directivos y operativos monitorear constantemente la salud del negocio y responder ágilmente ante desviaciones significativas.',
    benefits: [
      {
        title: 'Visibilidad inmediata',
        description: 'Acceso instantáneo al estado actual de métricas críticas',
      },
      {
        title: 'Alineación organizacional',
        description: 'Enfoque compartido en objetivos medibles y transparentes',
      },
      {
        title: 'Detección de tendencias',
        description: 'Identificación temprana de patrones y cambios significativos',
      },
      {
        title: 'Toma de decisiones ágil',
        description: 'Respuesta inmediata basada en datos actualizados constantemente',
      },
    ],
  },

  'Reportes automatizados': {
    name: 'Reportes automatizados',
    description:
      'Implementamos sistemas que generan, formatean y distribuyen informes críticos de negocio de manera totalmente automatizada. Nuestras soluciones programan la extracción y procesamiento de datos desde múltiples fuentes, aplican lógica de negocio personalizada, generan visualizaciones relevantes y entregan los reportes en los formatos requeridos (PDF, Excel, PowerPoint) a los destinatarios adecuados según calendarios predefinidos, eliminando tareas manuales repetitivas y garantizando consistencia en la información.',
    benefits: [
      {
        title: 'Eficiencia operativa',
        description: 'Eliminación de horas dedicadas a la generación manual de informes',
      },
      {
        title: 'Consistencia y precisión',
        description: 'Estandarización de cálculos y presentación sin errores humanos',
      },
      {
        title: 'Puntualidad garantizada',
        description: 'Entrega de información crítica en momentos predefinidos',
      },
      {
        title: 'Personalización avanzada',
        description: 'Adaptación de contenido y formato según audiencia y necesidades',
      },
    ],
  },

  'Integración con fuentes de datos': {
    name: 'Integración con fuentes de datos',
    description:
      'Desarrollamos soluciones que conectan y unifican datos provenientes de múltiples sistemas, aplicaciones y formatos heterogéneos. Mediante tecnologías ETL/ELT, APIs, webhooks y conectores especializados, implementamos arquitecturas de integración que extraen, transforman, validan y cargan datos desde fuentes internas y externas, creando una capa de datos unificada que proporciona una visión completa y consistente para análisis, reportes y aplicaciones de negocio.',
    benefits: [
      {
        title: 'Visión unificada',
        description: 'Eliminación de silos de información para análisis integral',
      },
      {
        title: 'Actualización automática',
        description: 'Sincronización programada o en tiempo real entre sistemas',
      },
      {
        title: 'Calidad de datos',
        description: 'Validación, limpieza y enriquecimiento durante el proceso de integración',
      },
      {
        title: 'Flexibilidad y escalabilidad',
        description: 'Adaptación ágil a nuevas fuentes y volúmenes crecientes de datos',
      },
    ],
  },

  'Diagnóstico digital': {
    name: 'Diagnóstico digital',
    description:
      'Realizamos una evaluación exhaustiva del estado actual de madurez digital de tu organización. Mediante metodologías estructuradas, analizamos infraestructura tecnológica, arquitectura de sistemas, procesos de negocio, capacidades del equipo y estrategia digital, identificando fortalezas, brechas y oportunidades de mejora. El diagnóstico proporciona una línea base clara y recomendaciones priorizadas para guiar tu proceso de transformación digital de manera efectiva.',
    benefits: [
      {
        title: 'Visión objetiva',
        description: 'Evaluación imparcial basada en benchmarks de industria',
      },
      {
        title: 'Priorización estratégica',
        description: 'Identificación de iniciativas de alto impacto y rápido retorno',
      },
      {
        title: 'Alineación organizacional',
        description: 'Creación de entendimiento compartido sobre el estado actual y objetivos',
      },
      {
        title: 'Mitigación de riesgos',
        description: 'Identificación temprana de obstáculos potenciales',
      },
    ],
  },

  'Roadmap de transformación': {
    name: 'Roadmap de transformación',
    description:
      'Desarrollamos un plan estratégico detallado que define la ruta, etapas, iniciativas y recursos necesarios para ejecutar tu transformación digital. Nuestro roadmap establece una secuencia lógica de proyectos con objetivos claros, dependencias, hitos medibles y asignación de responsabilidades, proporcionando una hoja de ruta integral que equilibra iniciativas de corto plazo con objetivos estratégicos de largo alcance, adaptada a tus capacidades organizacionales y prioridades de negocio.',
    benefits: [
      {
        title: 'Visión estratégica',
        description: 'Alineación de iniciativas tecnológicas con objetivos de negocio',
      },
      {
        title: 'Planificación realista',
        description: 'Secuenciación óptima considerando capacidades y restricciones',
      },
      {
        title: 'Gestión de expectativas',
        description: 'Comunicación clara de alcance, tiempos y resultados esperados',
      },
      {
        title: 'Adaptabilidad controlada',
        description: 'Flexibilidad para ajustar el plan manteniendo dirección estratégica',
      },
    ],
  },

  'Implementación de soluciones': {
    name: 'Implementación de soluciones',
    description:
      'Ejecutamos de manera integral los proyectos definidos en tu estrategia de transformación digital, desde la conceptualización hasta la puesta en producción. Nuestro enfoque metodológico combina prácticas ágiles y tradicionales para gestionar eficientemente el alcance, cronograma, recursos y riesgos, asegurando entregas de calidad que cumplen con los requisitos técnicos y de negocio, mientras minimizamos el impacto en las operaciones diarias durante la transición.',
    benefits: [
      {
        title: 'Ejecución controlada',
        description: 'Gestión rigurosa de alcance, tiempo, costo y calidad',
      },
      {
        title: 'Enfoque en valor',
        description: 'Priorización de funcionalidades con mayor impacto en resultados',
      },
      {
        title: 'Mitigación de riesgos',
        description: 'Identificación proactiva y gestión de obstáculos potenciales',
      },
      {
        title: 'Transferencia de conocimiento',
        description: 'Capacitación continua del equipo interno durante la implementación',
      },
    ],
  },

  'Capacitación de equipos': {
    name: 'Capacitación de equipos',
    description:
      'Diseñamos e implementamos programas de formación personalizados para desarrollar las competencias digitales que tu equipo necesita en el contexto de transformación. Mediante metodologías de aprendizaje experiencial, combinamos sesiones teóricas, talleres prácticos, simulaciones y acompañamiento en el puesto de trabajo, asegurando que los colaboradores no solo adquieran conocimientos técnicos sino también desarrollen la mentalidad y habilidades necesarias para operar eficazmente en el nuevo entorno digital.',
    benefits: [
      {
        title: 'Adopción acelerada',
        description: 'Reducción de resistencia al cambio y curva de aprendizaje',
      },
      {
        title: 'Autonomía operativa',
        description: 'Disminución de dependencia de consultores externos',
      },
      {
        title: 'Retención de talento',
        description: 'Aumento de compromiso mediante desarrollo profesional',
      },
      {
        title: 'Mejora continua',
        description: 'Capacidad interna para evolucionar y optimizar soluciones implementadas',
      },
    ],
  },

  'Gestión del cambio': {
    name: 'Gestión del cambio',
    description:
      'Implementamos estrategias estructuradas para facilitar la adopción de nuevas tecnologías, procesos y formas de trabajo en toda la organización. Nuestro enfoque integral aborda los aspectos humanos de la transformación mediante comunicación estratégica, gestión de expectativas, identificación y capacitación de agentes de cambio, y medición continua de adopción, asegurando que las personas comprendan, acepten y se comprometan con las iniciativas de transformación digital.',
    benefits: [
      {
        title: 'Reducción de resistencia',
        description: 'Mitigación proactiva de barreras culturales y organizacionales',
      },
      {
        title: 'Adopción sostenible',
        description: 'Incorporación de nuevas prácticas en la cultura organizacional',
      },
      {
        title: 'Maximización de ROI',
        description: 'Aprovechamiento completo de las capacidades implementadas',
      },
      {
        title: 'Transformación cultural',
        description: 'Desarrollo de mentalidad digital en todos los niveles de la organización',
      },
    ],
  },

  'Evaluación de infraestructura': {
    name: 'Evaluación de infraestructura',
    description:
      'Realizamos un análisis exhaustivo de tu infraestructura tecnológica actual para identificar fortalezas, debilidades y oportunidades de mejora. Mediante metodologías estructuradas y herramientas especializadas, evaluamos servidores, redes, almacenamiento, seguridad y sistemas operativos, generando un diagnóstico detallado que sirve como base para decisiones estratégicas y planificación de inversiones tecnológicas futuras.',
    benefits: [
      {
        title: 'Identificación de riesgos técnicos',
        description: 'Detección temprana de vulnerabilidades y puntos únicos de fallo',
      },
      {
        title: 'Mapa de obsolescencia',
        description: 'Planificación proactiva de actualizaciones y reemplazos necesarios',
      },
      {
        title: 'Análisis de capacidad',
        description: 'Evaluación precisa de recursos disponibles vs. necesidades reales',
      },
      {
        title: 'Recomendaciones priorizadas',
        description: 'Plan de acción estructurado según impacto y factibilidad',
      },
    ],
  },
  'Diseño de arquitectura': {
    name: 'Diseño de arquitectura',
    description:
      'Creamos planos tecnológicos detallados que definen la estructura óptima para tus sistemas de información. Utilizando frameworks reconocidos como TOGAF, Zachman o DoDAF, diseñamos arquitecturas que abarcan aplicaciones, datos, infraestructura y seguridad, considerando tanto tus necesidades actuales como tu visión de crecimiento futuro. Nuestros diseños establecen estándares, patrones y principios que guían el desarrollo coherente de tu ecosistema tecnológico.',
    benefits: [
      {
        title: 'Coherencia tecnológica',
        description: 'Eliminación de silos y redundancias en el ecosistema digital',
      },
      {
        title: 'Escalabilidad planificada',
        description: 'Diseños que anticipan el crecimiento sin requerir restructuraciones',
      },
      {
        title: 'Trazabilidad de decisiones',
        description: 'Documentación clara de elecciones arquitectónicas y sus fundamentos',
      },
      {
        title: 'Alineación con estándares',
        description: 'Cumplimiento de mejores prácticas y normativas del sector',
      },
    ],
  },
  'Optimización de recursos': {
    name: 'Optimización de recursos',
    description:
      'Maximizamos el rendimiento de tus activos tecnológicos mediante estrategias avanzadas de optimización. Analizamos patrones de uso, identificamos ineficiencias y aplicamos técnicas como consolidación de servidores, virtualización, automatización de procesos y balanceo de cargas para reducir costos operativos mientras mejoramos el desempeño. Nuestro enfoque data-driven garantiza que cada recurso tecnológico genere el máximo valor posible para tu organización.',
    benefits: [
      {
        title: 'Reducción de costos operativos',
        description: 'Disminución significativa en gastos de mantenimiento y licenciamiento',
      },
      {
        title: 'Eficiencia energética',
        description: 'Menor consumo eléctrico y huella de carbono en centros de datos',
      },
      {
        title: 'Aprovechamiento de capacidad',
        description: 'Utilización óptima de recursos computacionales disponibles',
      },
      {
        title: 'Simplificación administrativa',
        description: 'Reducción de complejidad en la gestión de activos tecnológicos',
      },
    ],
  },
  'Gestión de servicios TI': {
    name: 'Gestión de servicios TI',
    description:
      'Implementamos marcos de trabajo como ITIL o ISO/IEC 20000 para estructurar la entrega, soporte y mejora continua de tus servicios tecnológicos. Diseñamos procesos eficientes para gestión de incidentes, problemas, cambios, configuraciones y niveles de servicio, estableciendo métricas claras y canales de comunicación efectivos. Nuestro enfoque garantiza que tu departamento de TI opere como un proveedor de servicios estratégico, alineado con las necesidades del negocio.',
    benefits: [
      {
        title: 'Respuesta ágil a incidentes',
        description: 'Minimización de tiempos de resolución y su impacto en operaciones',
      },
      {
        title: 'Transparencia operativa',
        description: 'Visibilidad completa del estado y rendimiento de servicios TI',
      },
      {
        title: 'Mejora continua',
        description: 'Ciclos estructurados de evaluación y optimización de procesos',
      },
      {
        title: 'Gobierno efectivo',
        description: 'Control y supervisión de recursos tecnológicos alineados con políticas',
      },
    ],
  },
  'Recomendaciones técnicas': {
    name: 'Recomendaciones técnicas',
    description:
      'Proporcionamos orientación especializada basada en el análisis exhaustivo de tu ecosistema tecnológico. Nuestras recomendaciones técnicas combinan mejores prácticas de la industria, estándares internacionales y conocimiento de vanguardia para ofrecerte soluciones precisas a desafíos específicos. Cada recomendación incluye justificación técnica, análisis de impacto, estimación de recursos necesarios y priorización estratégica, permitiéndote tomar decisiones informadas sobre inversiones tecnológicas y cambios en infraestructura, arquitectura o procesos.',
    benefits: [
      {
        title: 'Fundamentación técnica',
        description: 'Respaldo de cada recomendación con evidencia y mejores prácticas',
      },
      {
        title: 'Priorización estratégica',
        description: 'Clasificación de acciones según impacto, urgencia y factibilidad',
      },
      {
        title: 'Independencia de proveedores',
        description: 'Asesoramiento imparcial no vinculado a tecnologías o marcas específicas',
      },
      {
        title: 'Viabilidad implementativa',
        description: 'Consideración de restricciones técnicas, presupuestarias y organizacionales',
      },
    ],
  },

  'Plan de modernización': {
    name: 'Plan de modernización',
    description:
      'Desarrollamos una estrategia integral para actualizar y transformar tu infraestructura tecnológica, aplicaciones y procesos digitales. Nuestro plan de modernización establece una secuencia lógica de iniciativas con objetivos claros, dependencias, hitos medibles y asignación de responsabilidades. Abordamos aspectos como migración a la nube, actualización de sistemas legacy, adopción de arquitecturas modernas y renovación de plataformas, equilibrando la necesidad de innovación con la gestión de riesgos y la continuidad operativa durante la transición.',
    benefits: [
      {
        title: 'Reducción de deuda técnica',
        description: 'Eliminación progresiva de sistemas obsoletos y tecnologías desactualizadas',
      },
      {
        title: 'Optimización de costos',
        description: 'Eficiencia en inversiones mediante consolidación y modernización selectiva',
      },
      {
        title: 'Agilidad tecnológica',
        description: 'Mayor capacidad de adaptación a cambios del mercado y nuevos requerimientos',
      },
      {
        title: 'Transición controlada',
        description: 'Minimización de riesgos operativos durante el proceso de modernización',
      },
    ],
  },

  'Auditoría de Innovación Tecnológica': {
    name: 'Auditoría de Innovación Tecnológica',
    description:
      'Realizamos un diagnóstico exhaustivo del ecosistema tecnológico de tu empresa para identificar oportunidades de mejora y optimización. Evaluamos la infraestructura actual, procesos digitales, herramientas y sistemas, analizando su alineación con los objetivos estratégicos del negocio y las tendencias del mercado. Nuestro enfoque metodológico combina análisis técnico, entrevistas con stakeholders y benchmarking sectorial para proporcionar una visión completa del estado tecnológico de la organización.',
    benefits: [
      {
        title: 'Diagnóstico integral',
        description: 'Evaluación holística de todos los componentes tecnológicos',
      },
      {
        title: 'Identificación de brechas',
        description: 'Detección de obsolescencias, ineficiencias y vulnerabilidades',
      },
      {
        title: 'Priorización estratégica',
        description: 'Clasificación de mejoras según impacto y viabilidad',
      },
      {
        title: 'Benchmarking competitivo',
        description: 'Comparativa con estándares del sector y mejores prácticas',
      },
    ],
  },

  'Benchmarking competitivo': {
    name: 'Benchmarking competitivo',
    description:
      'Realizamos análisis comparativos exhaustivos de tu empresa frente a competidores clave y referentes del sector. Mediante metodologías estructuradas, evaluamos procesos, estrategias, productos y resultados para identificar brechas de rendimiento, mejores prácticas y oportunidades de mejora, proporcionándote una visión clara de tu posicionamiento competitivo y recomendaciones accionables para superar a la competencia.',
    benefits: [
      {
        title: 'Identificación de mejores prácticas',
        description: 'Descubrimiento de estrategias exitosas implementadas por líderes del sector',
      },
      {
        title: 'Análisis de brechas competitivas',
        description:
          'Evaluación precisa de distancias entre tu rendimiento y el de competidores clave',
      },
      {
        title: 'Objetivos realistas',
        description: 'Establecimiento de metas basadas en estándares verificables del mercado',
      },
      {
        title: 'Priorización estratégica',
        description: 'Identificación de áreas críticas que requieren atención inmediata',
      },
    ],
  },

  'Roadmap tecnológico': {
    name: 'Roadmap tecnológico',
    description:
      'Creamos una hoja de ruta estratégica que define la evolución de tu ecosistema tecnológico a corto, mediano y largo plazo. Nuestro roadmap tecnológico alinea las iniciativas digitales con los objetivos de negocio, estableciendo una secuencia clara de proyectos, inversiones y adopción de tecnologías emergentes. Mediante un enfoque estructurado, definimos horizontes temporales, dependencias entre iniciativas, hitos clave y métricas de éxito, proporcionándote una visión clara del camino a seguir y facilitando la comunicación de la estrategia tecnológica a todos los niveles de la organización.',
    benefits: [
      {
        title: 'Alineación estratégica',
        description: 'Vinculación directa entre iniciativas tecnológicas y objetivos de negocio',
      },
      {
        title: 'Planificación de recursos',
        description: 'Previsión anticipada de necesidades presupuestarias y de talento',
      },
      {
        title: 'Gestión de expectativas',
        description: 'Comunicación clara de tiempos, alcances y resultados esperados',
      },
      {
        title: 'Adaptabilidad estructurada',
        description:
          'Flexibilidad para incorporar nuevas tecnologías sin perder dirección estratégica',
      },
    ],
  },

  'Informes ejecutivos con recomendaciones': {
    name: 'Informes ejecutivos con recomendaciones',
    description:
      'Elaboramos documentos estratégicos que sintetizan hallazgos clave de investigación y proporcionan directrices accionables. Nuestros informes combinan rigor analítico con claridad comunicativa, transformando datos complejos en narrativas coherentes que facilitan la toma de decisiones. Cada informe incluye visualizaciones efectivas, conclusiones fundamentadas y recomendaciones priorizadas con planes de implementación concretos, diseñados específicamente para impulsar resultados tangibles alineados con tus objetivos de negocio.',
    benefits: [
      {
        title: 'Síntesis estratégica',
        description: 'Condensación de información compleja en insights accionables',
      },
      {
        title: 'Visualización de datos',
        description: 'Representación gráfica clara de hallazgos clave para facilitar comprensión',
      },
      {
        title: 'Recomendaciones priorizadas',
        description: 'Propuestas concretas ordenadas por impacto potencial y factibilidad',
      },
      {
        title: 'Fundamento para decisiones',
        description: 'Base sólida de evidencia para respaldar iniciativas estratégicas',
      },
    ],
  },

  'Identificación de oportunidades de mercado': {
    name: 'Identificación de oportunidades de mercado',
    description:
      'Detectamos espacios de crecimiento y nichos desatendidos mediante análisis sistemático del mercado. Combinando investigación de tendencias, análisis de gaps competitivos y evaluación de necesidades emergentes, identificamos oportunidades viables para expansión, diversificación o innovación. Nuestro enfoque metodológico evalúa el potencial de cada oportunidad considerando factores como tamaño de mercado, barreras de entrada, rentabilidad proyectada y alineación estratégica con tus capacidades y objetivos.',
    benefits: [
      {
        title: 'Diversificación estratégica',
        description: 'Identificación de nuevos segmentos y verticales con potencial de crecimiento',
      },
      {
        title: 'Validación de conceptos',
        description: 'Evaluación preliminar de viabilidad comercial de nuevas ideas',
      },
      {
        title: 'Priorización de inversiones',
        description: 'Clasificación de oportunidades según potencial de retorno y factibilidad',
      },
      {
        title: 'Reducción de riesgos',
        description: 'Minimización de incertidumbre mediante análisis fundamentado de mercado',
      },
    ],
  },

  'Estudios de comportamiento del consumidor': {
    name: 'Estudios de comportamiento del consumidor',
    description:
      'Desarrollamos investigaciones profundas sobre los patrones de decisión, preferencias y motivaciones de tus clientes actuales y potenciales. Mediante metodologías cualitativas y cuantitativas (entrevistas, encuestas, análisis de datos, observación etnográfica), desentrañamos los factores psicológicos, sociales y contextuales que influyen en las decisiones de compra, permitiéndote desarrollar productos, servicios y comunicaciones perfectamente alineados con las necesidades reales de tu audiencia.',
    benefits: [
      {
        title: 'Segmentación avanzada',
        description:
          'Identificación de grupos de consumidores con necesidades y comportamientos homogéneos',
      },
      {
        title: 'Insights accionables',
        description: 'Descubrimiento de motivaciones profundas que impulsan decisiones de compra',
      },
      {
        title: 'Optimización de experiencia',
        description: 'Mejora de puntos de contacto basada en patrones reales de interacción',
      },
      {
        title: 'Predicción de tendencias',
        description: 'Anticipación a cambios en preferencias y comportamientos de consumo',
      },
    ],
  },

  'Diseño e implementación de flujos de trabajo': {
    name: 'Diseño e implementación de flujos de trabajo',
    description:
      'Optimizamos y automatizamos procesos administrativos mediante el diseño e implementación de flujos de trabajo digitales inteligentes. Utilizando tecnologías BPM (Business Process Management) y herramientas de automatización, creamos flujos que eliminan tareas redundantes, reducen errores manuales y aceleran los tiempos de ejecución. Nuestras soluciones incluyen aprobaciones multinivel, gestión documental integrada, notificaciones automáticas y dashboards de seguimiento en tiempo real.',
    benefits: [
      {
        title: 'Eficiencia operativa',
        description: 'Reducción de hasta 60% en tiempos de procesamiento administrativo',
      },
      {
        title: 'Control y trazabilidad',
        description: 'Seguimiento detallado de cada etapa del proceso con auditoría completa',
      },
      {
        title: 'Cumplimiento normativo',
        description: 'Estandarización de procesos según políticas y regulaciones vigentes',
      },
      {
        title: 'Escalabilidad',
        description: 'Capacidad para manejar volúmenes crecientes sin incrementar personal',
      },
    ],
  },

  'Digitalización y gestión documental': {
    name: 'Digitalización y gestión documental',
    description:
      'Implementamos sistemas integrales de gestión documental que transforman archivos físicos en activos digitales accesibles y seguros. Nuestra solución abarca desde la digitalización con OCR avanzado hasta la gestión del ciclo de vida completo de los documentos, incluyendo clasificación automática, versionado, políticas de retención y flujos de aprobación. Incorporamos búsqueda semántica y análisis de contenido para maximizar el valor de tu información corporativa.',
    benefits: [
      {
        title: 'Accesibilidad inmediata',
        description: 'Recuperación instantánea de documentos desde cualquier ubicación autorizada',
      },
      {
        title: 'Gobierno documental',
        description: 'Control centralizado de versiones, permisos y ciclo de vida documental',
      },
      {
        title: 'Optimización de espacio',
        description: 'Eliminación de archivos físicos y reducción de costos de almacenamiento',
      },
      {
        title: 'Colaboración efectiva',
        description: 'Trabajo simultáneo sobre documentos con control de cambios y comentarios',
      },
    ],
  },

  'Implementación de sistemas de gestión': {
    name: 'Implementación de sistemas de gestión',
    description:
      'Desarrollamos e implementamos sistemas de gestión empresarial que integran y optimizan los procesos administrativos clave de tu organización. Mediante la configuración de plataformas ERP, CRM y sistemas especializados, creamos un ecosistema digital cohesivo que centraliza la información, automatiza operaciones y proporciona visibilidad completa del desempeño organizacional. Nuestras implementaciones siguen metodologías ágiles adaptadas a tus necesidades específicas.',
    benefits: [
      {
        title: 'Integración total',
        description: 'Unificación de datos y procesos en una única plataforma coherente',
      },
      {
        title: 'Automatización inteligente',
        description: 'Reducción de tareas manuales y eliminación de duplicidades',
      },
      {
        title: 'Análisis en tiempo real',
        description: 'Dashboards personalizados con KPIs clave para toma de decisiones',
      },
      {
        title: 'Adaptabilidad empresarial',
        description: 'Flexibilidad para evolucionar según necesidades del negocio',
      },
    ],
  },

  'Planificación estratégica y alcance': {
    name: 'Planificación estratégica y alcance',
    description:
      'Desarrollamos planes de proyecto exhaustivos que establecen claramente objetivos, entregables, cronogramas y límites del proyecto. Mediante metodologías probadas como PMI y marcos ágiles, definimos un alcance realista y medible alineado con objetivos estratégicos, identificando dependencias críticas, riesgos potenciales y estableciendo mecanismos efectivos de control de cambios.',
    benefits: [
      {
        title: 'Alineación estratégica',
        description: 'Vinculación directa entre objetivos del proyecto y metas organizacionales',
      },
      {
        title: 'Definición precisa',
        description: 'Establecimiento claro de entregables y criterios de aceptación',
      },
      {
        title: 'Gestión de riesgos',
        description: 'Identificación temprana y planes de mitigación de riesgos potenciales',
      },
      {
        title: 'Control de cambios',
        description: 'Proceso estructurado para evaluar y aprobar modificaciones al alcance',
      },
    ],
  },

  'Control y seguimiento de hitos': {
    name: 'Control y seguimiento de hitos',
    description:
      'Implementamos sistemas integrales de monitoreo para supervisar el avance del proyecto contra la planificación establecida. Utilizamos dashboards personalizados que visualizan el progreso en tiempo real, metodologías de seguimiento estructuradas y procesos rigurosos de control de calidad para asegurar el cumplimiento de hitos y entregables según los estándares definidos.',
    benefits: [
      {
        title: 'Monitoreo en tiempo real',
        description: 'Dashboards actualizados con indicadores clave de desempeño (KPIs)',
      },
      {
        title: 'Detección temprana',
        description: 'Identificación proactiva de desviaciones y problemas potenciales',
      },
      {
        title: 'Aseguramiento de calidad',
        description: 'Verificación sistemática del cumplimiento de requisitos',
      },
      {
        title: 'Comunicación efectiva',
        description: 'Reportes de estado claros y concisos para stakeholders',
      },
    ],
  },

  'Evaluación de resultados y mejora': {
    name: 'Evaluación de resultados y mejora',
    description:
      'Aplicamos metodologías sistemáticas para evaluar el desempeño del proyecto y capturar lecciones aprendidas. Realizamos análisis post-implementación, conducimos sesiones de retrospectiva estructuradas, documentamos mejores prácticas y desarrollamos planes de acción concretos para optimizar la gestión de futuros proyectos.',
    benefits: [
      {
        title: 'Aprendizaje organizacional',
        description: 'Capitalización de experiencias para proyectos futuros',
      },
      {
        title: 'Medición de impacto',
        description: 'Evaluación objetiva del valor generado para el negocio',
      },
      {
        title: 'Mejora continua',
        description: 'Optimización constante de metodologías y prácticas',
      },
      {
        title: 'Gestión del conocimiento',
        description: 'Documentación estructurada de lecciones aprendidas',
      },
    ],
  },

  'Metodologías ágiles y tradicionales': {
    name: 'Metodologías ágiles y tradicionales',
    description:
      'Implementamos un enfoque híbrido que combina las mejores prácticas de metodologías ágiles (Scrum, Kanban) y marcos tradicionales (PMBOK, PRINCE2) para gestionar proyectos estratégicos. Nuestro enfoque adaptativo permite equilibrar la estructura y documentación necesarias con la flexibilidad para responder a cambios, asegurando una gestión eficiente que maximiza el valor entregado. Seleccionamos y personalizamos la metodología más adecuada según la naturaleza del proyecto, objetivos estratégicos y cultura organizacional.',
    benefits: [
      {
        title: 'Flexibilidad metodológica',
        description: 'Adaptación del marco de trabajo según complejidad y contexto del proyecto',
      },
      {
        title: 'Gestión del cambio',
        description: 'Capacidad de respuesta ágil manteniendo control y visibilidad',
      },
      {
        title: 'Entrega continua',
        description: 'Generación de valor incremental con feedback temprano',
      },
      {
        title: 'Gobierno efectivo',
        description: 'Balance entre agilidad y cumplimiento de procesos formales',
      },
    ],
  },

  'Investigación de mercados': {
    name: 'Investigación de mercados',
    description:
      'Realizamos estudios exhaustivos de mercado utilizando metodologías cuantitativas y cualitativas para proporcionar insights accionables sobre tendencias, comportamientos del consumidor y oportunidades de mercado. Combinamos técnicas como encuestas, entrevistas en profundidad, focus groups y análisis de datos secundarios para generar una comprensión integral del mercado que fundamenta la toma de decisiones estratégicas.',
    benefits: [
      {
        title: 'Insights accionables',
        description: 'Información relevante y práctica para toma de decisiones estratégicas',
      },
      {
        title: 'Metodología rigurosa',
        description: 'Combinación de técnicas cualitativas y cuantitativas validadas',
      },
      {
        title: 'Análisis contextualizado',
        description: 'Interpretación de datos considerando factores del entorno específico',
      },
      {
        title: 'Recomendaciones estratégicas',
        description: 'Propuestas concretas basadas en hallazgos de la investigación',
      },
    ],
  },

  'Análisis de tendencias sectoriales': {
    name: 'Análisis de tendencias sectoriales',
    description:
      'Monitorizamos y analizamos continuamente las tendencias emergentes en tu sector, identificando patrones, innovaciones disruptivas y cambios en el comportamiento del consumidor que pueden impactar tu negocio. Mediante herramientas avanzadas de análisis y fuentes especializadas, proporcionamos una visión prospectiva que te permite anticiparte a los cambios del mercado.',
    benefits: [
      {
        title: 'Anticipación estratégica',
        description: 'Identificación temprana de oportunidades y amenazas emergentes',
      },
      {
        title: 'Contexto competitivo',
        description: 'Comprensión profunda del ecosistema sectorial y su evolución',
      },
      {
        title: 'Innovación guiada',
        description: 'Dirección clara para iniciativas de desarrollo de productos/servicios',
      },
      {
        title: 'Validación de estrategias',
        description: 'Contraste de decisiones estratégicas con tendencias de mercado',
      },
    ],
  },

  'Metodologías de Design Thinking': {
    name: 'Metodologías de Design Thinking',
    description:
      'Implementamos metodologías centradas en el usuario que fomentan la innovación y resolución creativa de problemas. Mediante un proceso iterativo de empatía, definición, ideación, prototipado y validación, facilitamos la generación de soluciones innovadoras que responden a necesidades reales de usuarios y objetivos de negocio. Nuestro enfoque combina talleres participativos, investigación etnográfica y técnicas de co-creación.',
    benefits: [
      {
        title: 'Innovación centrada en usuario',
        description: 'Soluciones que responden a necesidades reales del mercado',
      },
      {
        title: 'Proceso iterativo',
        description: 'Refinamiento continuo basado en feedback temprano',
      },
      {
        title: 'Colaboración multidisciplinar',
        description: 'Integración de perspectivas diversas en el proceso creativo',
      },
      {
        title: 'Reducción de riesgos',
        description: 'Validación temprana de conceptos antes de la implementación',
      },
    ],
  },

  'Gestión de proyectos de I+D': {
    name: 'Gestión de proyectos de I+D',
    description:
      'Dirigimos proyectos de investigación y desarrollo desde la conceptualización hasta la implementación, aplicando metodologías ágiles adaptadas a la naturaleza experimental de la innovación. Gestionamos equipos multidisciplinares, recursos técnicos, propiedad intelectual y colaboraciones con centros de investigación, asegurando el equilibrio entre exploración creativa y resultados tangibles.',
    benefits: [
      {
        title: 'Gestión especializada',
        description: 'Metodologías adaptadas a la naturaleza única de proyectos I+D',
      },
      {
        title: 'Protección intelectual',
        description: 'Salvaguarda de innovaciones y desarrollos propietarios',
      },
      {
        title: 'Optimización de recursos',
        description: 'Maximización del retorno en inversión en investigación',
      },
      {
        title: 'Transferencia tecnológica',
        description: 'Puente efectivo entre investigación y aplicación práctica',
      },
    ],
  },

  'Prototipado y validación': {
    name: 'Prototipado y validación',
    description:
      'Desarrollamos prototipos funcionales y pruebas de concepto que permiten validar hipótesis y refinar soluciones antes de la implementación a gran escala. Utilizamos técnicas de prototipado rápido, impresión 3D, simulaciones digitales y testing con usuarios reales para obtener feedback temprano y minimizar riesgos en el desarrollo.',
    benefits: [
      {
        title: 'Validación temprana',
        description: 'Verificación de conceptos antes de inversiones significativas',
      },
      {
        title: 'Iteración ágil',
        description: 'Refinamiento continuo basado en feedback de usuarios',
      },
      {
        title: 'Reducción de costos',
        description: 'Minimización de errores en fases tempranas de desarrollo',
      },
      {
        title: 'Evidencia tangible',
        description: 'Demostración práctica de conceptos innovadores',
      },
    ],
  },

  'Estudios de factibilidad técnica': {
    name: 'Estudios de factibilidad técnica',
    description:
      'Realizamos análisis exhaustivos para evaluar la viabilidad técnica, operativa y económica de proyectos innovadores. Examinamos requisitos tecnológicos, recursos necesarios, restricciones técnicas y regulatorias, estimando costos y tiempos de implementación para fundamentar decisiones de inversión.',
    benefits: [
      {
        title: 'Evaluación integral',
        description: 'Análisis multidimensional de viabilidad del proyecto',
      },
      {
        title: 'Mitigación de riesgos',
        description: 'Identificación temprana de obstáculos técnicos',
      },
      {
        title: 'Planificación realista',
        description: 'Estimaciones fundamentadas de recursos y plazos',
      },
      {
        title: 'Decisiones informadas',
        description: 'Base sólida para decisiones de inversión en innovación',
      },
    ],
  },

  'Implementación de soluciones innovadoras': {
    name: 'Implementación de soluciones innovadoras',
    description:
      'Ejecutamos la implementación de soluciones innovadoras garantizando su integración efectiva en el entorno operativo existente. Gestionamos el cambio organizacional, capacitación de usuarios, migración de datos y optimización de procesos, asegurando la adopción exitosa y el retorno de inversión esperado.',
    benefits: [
      {
        title: 'Integración efectiva',
        description: 'Incorporación fluida en ecosistemas existentes',
      },
      {
        title: 'Gestión del cambio',
        description: 'Acompañamiento en la transformación organizacional',
      },
      {
        title: 'Transferencia de conocimiento',
        description: 'Capacitación y documentación para autonomía operativa',
      },
      {
        title: 'Medición de impacto',
        description: 'Evaluación continua de resultados y beneficios',
      },
    ],
  },

  'Asesoramiento ejecutivo continuo': {
    name: 'Asesoramiento ejecutivo continuo',
    description:
      'Proporcionamos acompañamiento estratégico permanente a nivel directivo, ofreciendo orientación experta para la toma de decisiones críticas. Nuestro equipo de consultores senior trabaja estrechamente con su equipo ejecutivo, aportando perspectivas externas valiosas, identificando oportunidades estratégicas y ayudando a navegar desafíos complejos del mercado.',
    benefits: [
      {
        title: 'Perspectiva estratégica',
        description: 'Visión externa e imparcial para decisiones críticas',
      },
      {
        title: 'Respuesta ágil',
        description: 'Soporte inmediato ante desafíos emergentes',
      },
      {
        title: 'Acceso a expertise',
        description: 'Conocimiento especializado en múltiples industrias',
      },
      {
        title: 'Confidencialidad total',
        description: 'Manejo discreto de información sensible',
      },
    ],
  },

  'Análisis estratégico de mercado': {
    name: 'Análisis estratégico de mercado',
    description:
      'Realizamos estudios exhaustivos del entorno competitivo, tendencias de mercado y comportamiento del consumidor para identificar oportunidades de crecimiento. Mediante metodologías avanzadas de investigación y análisis de datos, proporcionamos insights accionables sobre posicionamiento competitivo, segmentos de mercado desatendidos y estrategias de diferenciación efectivas para su negocio.',
    benefits: [
      {
        title: 'Identificación de oportunidades',
        description: 'Detección de nichos y segmentos de alto potencial',
      },
      {
        title: 'Ventaja competitiva',
        description: 'Estrategias de diferenciación basadas en datos',
      },
      {
        title: 'Reducción de riesgos',
        description: 'Anticipación a cambios y amenazas del mercado',
      },
      {
        title: 'Decisiones fundamentadas',
        description: 'Información de calidad para orientar inversiones',
      },
    ],
  },

  'Planificación de crecimiento a largo plazo': {
    name: 'Planificación de crecimiento a largo plazo',
    description:
      'Desarrollamos planes estratégicos integrales para el crecimiento sostenible de su organización en horizontes de 3 a 5 años. Combinando análisis de tendencias, evaluación de capacidades internas y oportunidades de mercado, creamos hojas de ruta detalladas con objetivos claros, iniciativas priorizadas y métricas de seguimiento que alinean recursos y esfuerzos hacia una visión compartida de éxito.',
    benefits: [
      {
        title: 'Visión estratégica',
        description: 'Claridad en objetivos y dirección a largo plazo',
      },
      {
        title: 'Alineación organizacional',
        description: 'Convergencia de esfuerzos hacia metas comunes',
      },
      {
        title: 'Adaptabilidad estructurada',
        description: 'Flexibilidad para ajustar el rumbo manteniendo el norte',
      },
      {
        title: 'Gestión de recursos',
        description: 'Optimización de inversiones para máximo impacto',
      },
    ],
  },

  'Optimización de procesos críticos': {
    name: 'Optimización de procesos críticos',
    description:
      'Analizamos y rediseñamos los procesos fundamentales de su negocio para maximizar eficiencia, calidad y valor entregado. Mediante metodologías de mejora continua y reingeniería, identificamos cuellos de botella, actividades sin valor agregado y oportunidades de automatización, implementando soluciones que reducen costos operativos, acortan tiempos de ciclo y mejoran la experiencia de clientes y colaboradores.',
    benefits: [
      {
        title: 'Eficiencia operativa',
        description: 'Reducción de costos y tiempos de procesamiento',
      },
      {
        title: 'Calidad consistente',
        description: 'Estandarización y reducción de variabilidad',
      },
      {
        title: 'Escalabilidad mejorada',
        description: 'Capacidad para crecer sin incrementar complejidad',
      },
      {
        title: 'Experiencia superior',
        description: 'Mejora en satisfacción de clientes y empleados',
      },
    ],
  },

  'Estudios de viabilidad comercial': {
    name: 'Estudios de viabilidad comercial',
    description:
      'Realizamos análisis exhaustivos para evaluar la viabilidad comercial de nuevos proyectos o líneas de negocio. Mediante metodologías estructuradas, evaluamos el potencial de mercado, proyecciones financieras, requisitos operativos y factores críticos de éxito, proporcionando una base sólida para la toma de decisiones de inversión.',
    benefits: [
      {
        title: 'Validación de mercado',
        description: 'Confirmación de demanda real y disposición de compra',
      },
      {
        title: 'Análisis financiero',
        description: 'Proyecciones detalladas de ingresos, costos y rentabilidad',
      },
      {
        title: 'Evaluación operativa',
        description: 'Identificación de recursos y capacidades necesarias',
      },
      {
        title: 'Reducción de riesgos',
        description: 'Validación preliminar antes de inversiones significativas',
      },
    ],
  },

  'Análisis de mercados potenciales': {
    name: 'Análisis de mercados potenciales',
    description:
      'Identificamos y evaluamos nuevos mercados con potencial de crecimiento para tu negocio. Mediante investigación exhaustiva, analizamos tendencias, tamaño de mercado, competencia, barreras de entrada y factores regulatorios, permitiéndote tomar decisiones informadas sobre expansión geográfica o diversificación de mercados.',
    benefits: [
      {
        title: 'Oportunidades de expansión',
        description: 'Identificación de mercados atractivos para crecimiento',
      },
      {
        title: 'Análisis competitivo',
        description: 'Evaluación detallada del panorama competitivo',
      },
      {
        title: 'Estrategia de entrada',
        description: 'Recomendaciones sobre modo y timing de entrada',
      },
      {
        title: 'Potencial de crecimiento',
        description: 'Estimación fundamentada del potencial de mercado',
      },
    ],
  },

  'Desarrollo de modelos de negocio': {
    name: 'Desarrollo de modelos de negocio',
    description:
      'Diseñamos e innovamos modelos de negocio utilizando metodologías como Business Model Canvas y Value Proposition Design. Analizamos y definimos propuestas de valor, segmentos de clientes, canales, recursos clave y estructuras de costos e ingresos para crear modelos sostenibles y escalables.',
    benefits: [
      {
        title: 'Innovación estratégica',
        description: 'Diseño de modelos disruptivos y diferenciadores',
      },
      {
        title: 'Validación iterativa',
        description: 'Testeo y refinamiento continuo del modelo',
      },
      {
        title: 'Escalabilidad',
        description: 'Diseño orientado al crecimiento sostenible',
      },
      {
        title: 'Ventaja competitiva',
        description: 'Identificación de factores únicos de diferenciación',
      },
    ],
  },

  'Evaluación de riesgos y oportunidades': {
    name: 'Evaluación de riesgos y oportunidades',
    description:
      'Implementamos un análisis sistemático de riesgos y oportunidades asociados con nuevas iniciativas de negocio. Utilizamos matrices de riesgo, análisis FODA avanzado y metodologías de gestión de riesgos para identificar, evaluar y desarrollar estrategias de mitigación y aprovechamiento.',
    benefits: [
      {
        title: 'Gestión proactiva',
        description: 'Identificación temprana de amenazas y oportunidades',
      },
      {
        title: 'Estrategias de mitigación',
        description: 'Planes concretos para gestionar riesgos identificados',
      },
      {
        title: 'Aprovechamiento estratégico',
        description: 'Maximización de oportunidades detectadas',
      },
      {
        title: 'Toma de decisiones informada',
        description: 'Base sólida para decisiones estratégicas',
      },
    ],
  },

  'Planificación estratégica': {
    name: 'Planificación estratégica',
    description:
      'Desarrollamos planes estratégicos integrales que definen la dirección y objetivos de largo plazo para tu negocio. Mediante metodologías probadas, establecemos metas claras, estrategias de implementación, KPIs y planes de acción, asegurando una hoja de ruta clara para el crecimiento sostenible.',
    benefits: [
      {
        title: 'Visión clara',
        description: 'Definición precisa de objetivos y dirección estratégica',
      },
      {
        title: 'Alineación organizacional',
        description: 'Coordinación de recursos hacia metas comunes',
      },
      {
        title: 'Métricas de éxito',
        description: 'KPIs claros para seguimiento de progreso',
      },
      {
        title: 'Plan de implementación',
        description: 'Hoja de ruta detallada para ejecución efectiva',
      },
    ],
  },

  'Diagnóstico de necesidades formativas': {
    name: 'Diagnóstico de necesidades formativas',
    description:
      'Realizamos una evaluación exhaustiva para identificar brechas de conocimiento y habilidades en la organización. Mediante metodologías estructuradas que incluyen evaluaciones, entrevistas, observación directa y análisis de desempeño, determinamos las necesidades específicas de capacitación alineadas con los objetivos estratégicos del negocio.',
    benefits: [
      {
        title: 'Análisis personalizado',
        description: 'Identificación precisa de necesidades específicas por área y nivel',
      },
      {
        title: 'Alineación estratégica',
        description: 'Vinculación directa entre formación y objetivos organizacionales',
      },
      {
        title: 'Optimización de recursos',
        description: 'Priorización eficiente de iniciativas formativas según impacto',
      },
      {
        title: 'Base fundamentada',
        description: 'Diseño de programas basado en necesidades reales validadas',
      },
    ],
  },

  'Metodología hands-on': {
    name: 'Metodología hands-on',
    description:
      'Implementamos un enfoque práctico y experiencial que maximiza la retención y aplicación del aprendizaje. A través de ejercicios prácticos, simulaciones, casos reales y proyectos aplicados, los participantes desarrollan competencias mediante la experiencia directa y la resolución de desafíos contextualizados a su realidad laboral.',
    benefits: [
      {
        title: 'Aprendizaje activo',
        description: 'Participación directa en la construcción del conocimiento',
      },
      {
        title: 'Aplicación inmediata',
        description: 'Transferencia directa de aprendizajes al contexto laboral',
      },
      {
        title: 'Mayor retención',
        description: 'Consolidación de conocimientos mediante práctica continua',
      },
      {
        title: 'Contextualización real',
        description: 'Ejercicios y casos adaptados a la realidad organizacional',
      },
    ],
  },

  'Evaluación de competencias digitales': {
    name: 'Evaluación de competencias digitales',
    description:
      'Realizamos un diagnóstico integral del nivel de madurez digital de los colaboradores mediante frameworks especializados. Evaluamos habilidades técnicas, comprensión de tecnologías emergentes, capacidad de adaptación digital y competencias específicas requeridas para roles actuales y futuros.',
    benefits: [
      {
        title: 'Mapeo de competencias',
        description: 'Identificación detallada de habilidades actuales vs. requeridas',
      },
      {
        title: 'Planes personalizados',
        description: 'Rutas de desarrollo adaptadas a cada perfil y nivel',
      },
      {
        title: 'Medición objetiva',
        description: 'Evaluación estandarizada con métricas claras de progreso',
      },
      {
        title: 'Visión prospectiva',
        description: 'Anticipación a necesidades futuras de competencias digitales',
      },
    ],
  },

  'Seguimiento de resultados': {
    name: 'Seguimiento de resultados',
    description:
      'Implementamos un sistema integral de monitoreo y evaluación del impacto de los programas formativos. Mediante KPIs específicos, evaluaciones periódicas, encuestas de satisfacción y medición de aplicación práctica, aseguramos el cumplimiento de objetivos y el retorno de la inversión en formación.',
    benefits: [
      {
        title: 'Medición continua',
        description: 'Monitoreo sistemático del progreso y efectividad del programa',
      },
      {
        title: 'ROI formativo',
        description: 'Evaluación del impacto y retorno de la inversión en capacitación',
      },
      {
        title: 'Mejora iterativa',
        description: 'Ajuste continuo del programa basado en resultados',
      },
      {
        title: 'Reportes ejecutivos',
        description: 'Informes detallados de avance y logros del programa',
      },
    ],
  },

  'Herramientas digitales avanzadas': {
    name: 'Herramientas digitales avanzadas',
    description:
      'Capacitación práctica en el uso de herramientas tecnológicas de vanguardia específicas para cada sector y función. Incorporamos las últimas tecnologías y plataformas relevantes para tu industria, proporcionando experiencia hands-on en entornos controlados que simulan escenarios reales de trabajo.',
    benefits: [
      {
        title: 'Actualización tecnológica',
        description: 'Dominio de las últimas herramientas y tecnologías del mercado',
      },
      {
        title: 'Aplicación práctica',
        description: 'Ejercicios guiados en herramientas específicas del sector',
      },
      {
        title: 'Personalización sectorial',
        description: 'Selección de herramientas según necesidades específicas',
      },
      {
        title: 'Autonomía operativa',
        description: 'Capacidad de implementación independiente post-formación',
      },
    ],
  },

  'Prácticas con casos reales': {
    name: 'Prácticas con casos reales',
    description:
      'Desarrollamos ejercicios y simulaciones basados en situaciones reales de negocio, permitiendo a los participantes aplicar lo aprendido en contextos relevantes y significativos. Utilizamos casos de estudio documentados, proyectos previos anonimizados y escenarios adaptados de la industria para proporcionar una experiencia de aprendizaje auténtica y transferible.',
    benefits: [
      {
        title: 'Aprendizaje contextualizado',
        description: 'Ejercicios basados en situaciones reales del sector',
      },
      {
        title: 'Desarrollo de criterio',
        description: 'Toma de decisiones en escenarios complejos y realistas',
      },
      {
        title: 'Transferencia inmediata',
        description: 'Aplicación directa de aprendizajes al entorno laboral',
      },
      {
        title: 'Experiencia práctica',
        description: 'Desarrollo de habilidades mediante casos documentados',
      },
    ],
  },

  'Sesiones interactivas': {
    name: 'Sesiones interactivas',
    description:
      'Implementamos metodologías participativas que fomentan el aprendizaje activo y colaborativo. A través de dinámicas grupales, discusiones facilitadas, ejercicios de resolución de problemas y actividades de co-creación, mantenemos altos niveles de engagement y facilitamos la construcción colectiva de conocimiento.',
    benefits: [
      {
        title: 'Participación activa',
        description: 'Involucramiento constante de los participantes',
      },
      {
        title: 'Aprendizaje colaborativo',
        description: 'Intercambio de experiencias y conocimientos entre participantes',
      },
      {
        title: 'Dinamismo metodológico',
        description: 'Variedad de técnicas para mantener el interés y la atención',
      },
      {
        title: 'Retroalimentación inmediata',
        description: 'Feedback continuo para ajustar y reforzar el aprendizaje',
      },
    ],
  },

  'Evaluación de aprendizaje': {
    name: 'Evaluación de aprendizaje',
    description:
      'Implementamos un sistema integral de evaluación que mide la adquisición de conocimientos y competencias a lo largo del proceso formativo. Combinamos evaluaciones diagnósticas, formativas y sumativas con métodos cualitativos y cuantitativos para asegurar la efectividad del aprendizaje y su aplicación práctica.',
    benefits: [
      {
        title: 'Medición objetiva',
        description: 'Evaluación sistemática del progreso y resultados',
      },
      {
        title: 'Retroalimentación constructiva',
        description: 'Identificación de áreas de mejora y fortalezas',
      },
      {
        title: 'Ajuste continuo',
        description: 'Adaptación del programa según resultados de evaluación',
      },
      {
        title: 'Certificación de competencias',
        description: 'Validación formal de conocimientos adquiridos',
      },
    ],
  },

  'Plan de desarrollo personalizado': {
    name: 'Plan de desarrollo personalizado',
    description:
      'Diseñamos planes de desarrollo ejecutivo individualizados que combinan el fortalecimiento de competencias tecnológicas con habilidades de liderazgo digital. Mediante evaluaciones específicas y análisis de necesidades, creamos rutas de aprendizaje adaptadas que establecen objetivos claros, hitos medibles y recursos especializados para potenciar el perfil directivo en el contexto de transformación digital.',
    benefits: [
      {
        title: 'Customización total',
        description: 'Adaptación precisa a necesidades y objetivos individuales',
      },
      {
        title: 'Progresión estructurada',
        description: 'Secuencia lógica de desarrollo de competencias digitales',
      },
      {
        title: 'Medición de avance',
        description: 'KPIs claros para seguimiento de desarrollo profesional',
      },
      {
        title: 'Flexibilidad adaptativa',
        description: 'Ajuste dinámico según evolución y nuevos requerimientos',
      },
    ],
  },

  'Sesiones one-to-one': {
    name: 'Sesiones one-to-one',
    description:
      'Facilitamos sesiones personalizadas con mentores expertos en transformación digital y liderazgo tecnológico. Las sesiones combinan orientación estratégica, resolución de desafíos específicos y desarrollo de competencias digitales, proporcionando un espacio confidencial para explorar oportunidades, validar decisiones y acelerar el crecimiento profesional en el ámbito tecnológico.',
    benefits: [
      {
        title: 'Atención exclusiva',
        description: 'Enfoque dedicado a desafíos específicos del ejecutivo',
      },
      {
        title: 'Expertise especializada',
        description: 'Acceso a conocimiento de líderes en transformación digital',
      },
      {
        title: 'Feedback inmediato',
        description: 'Retroalimentación directa y aplicable en tiempo real',
      },
      {
        title: 'Confidencialidad total',
        description: 'Ambiente seguro para abordar temas sensibles',
      },
    ],
  },

  'Seguimiento de objetivos': {
    name: 'Seguimiento de objetivos',
    description:
      'Implementamos un sistema integral de monitoreo y evaluación del progreso hacia los objetivos de desarrollo establecidos. Mediante herramientas digitales y sesiones periódicas de revisión, monitoreamos el avance, identificamos obstáculos, ajustamos estrategias y celebramos logros, asegurando un desarrollo ejecutivo efectivo y medible.',
    benefits: [
      {
        title: 'Monitoreo continuo',
        description: 'Seguimiento sistemático del progreso y logros',
      },
      {
        title: 'Ajustes dinámicos',
        description: 'Adaptación ágil de estrategias según resultados',
      },
      {
        title: 'Documentación estructurada',
        description: 'Registro detallado de avances y aprendizajes',
      },
      {
        title: 'Celebración de logros',
        description: 'Reconocimiento formal de hitos alcanzados',
      },
    ],
  },

  'Recursos especializados': {
    name: 'Recursos especializados',
    description:
      'Proporcionamos acceso a un ecosistema completo de recursos de aprendizaje y desarrollo ejecutivo en tecnología. Incluye biblioteca digital curada, herramientas de autodiagnóstico, plataformas de e-learning, casos de estudio, simulaciones y conexión con una red de expertos en diferentes áreas de transformación digital.',
    benefits: [
      {
        title: 'Contenido premium',
        description: 'Acceso a recursos de alta calidad y actualidad',
      },
      {
        title: 'Aprendizaje multimodal',
        description: 'Variedad de formatos para diferentes estilos de aprendizaje',
      },
      {
        title: 'Red de expertos',
        description: 'Conexión con especialistas en tecnologías específicas',
      },
      {
        title: 'Actualización continua',
        description: 'Recursos constantemente renovados según tendencias',
      },
    ],
  },

  'Fundamentos de IA y ML': {
    name: 'Fundamentos de IA y ML',
    description:
      'Proporcionamos formación fundamental en inteligencia artificial y machine learning adaptada al contexto empresarial. Cubrimos conceptos clave, tipos de algoritmos, procesamiento de datos, y frameworks populares, enfocándonos en su aplicación práctica para resolver desafíos de negocio reales. El programa combina teoría esencial con ejemplos prácticos del mundo empresarial.',
    benefits: [
      {
        title: 'Base conceptual sólida',
        description: 'Comprensión profunda de principios y tecnologías clave de IA',
      },
      {
        title: 'Enfoque práctico',
        description: 'Conexión directa entre teoría y aplicaciones empresariales',
      },
      {
        title: 'Desarrollo progresivo',
        description: 'Estructura modular que facilita el aprendizaje gradual',
      },
      {
        title: 'Actualización continua',
        description: 'Contenido alineado con las últimas tendencias en IA',
      },
    ],
  },

  'Casos de uso empresariales': {
    name: 'Casos de uso empresariales',
    description:
      'Analizamos casos reales de implementación de IA en diferentes sectores y funciones empresariales. Estudiamos ejemplos detallados de automatización inteligente, análisis predictivo, optimización de procesos y sistemas de recomendación, explorando factores de éxito, desafíos enfrentados y lecciones aprendidas en cada implementación.',
    benefits: [
      {
        title: 'Aprendizaje contextualizado',
        description: 'Ejemplos relevantes específicos para cada industria',
      },
      {
        title: 'Mejores prácticas',
        description: 'Identificación de factores clave de éxito en implementaciones',
      },
      {
        title: 'Análisis de impacto',
        description: 'Evaluación de resultados y beneficios obtenidos',
      },
      {
        title: 'Gestión de desafíos',
        description: 'Estrategias probadas para superar obstáculos comunes',
      },
    ],
  },

  'Implementación práctica': {
    name: 'Implementación práctica',
    description:
      'Facilitamos experiencia hands-on en la implementación de soluciones de IA mediante workshops prácticos y proyectos guiados. Los participantes trabajan con herramientas reales, desarrollan modelos, procesan datos y despliegan soluciones en entornos controlados que simulan escenarios empresariales.',
    benefits: [
      {
        title: 'Experiencia directa',
        description: 'Trabajo práctico con herramientas y tecnologías actuales',
      },
      {
        title: 'Proyectos reales',
        description: 'Desarrollo de soluciones para casos de uso específicos',
      },
      {
        title: 'Mentoría especializada',
        description: 'Guía experta durante el proceso de implementación',
      },
      {
        title: 'Portafolio práctico',
        description: 'Construcción de experiencia demostrable en IA',
      },
    ],
  },

  'Gestión de proyectos de IA': {
    name: 'Gestión de proyectos de IA',
    description:
      'Enseñamos metodologías específicas para liderar proyectos de IA, abordando aspectos únicos como la gestión de datos, experimentación iterativa, validación de modelos y despliegue en producción. Incluimos frameworks ágiles adaptados, gestión de equipos multidisciplinares y consideraciones éticas.',
    benefits: [
      {
        title: 'Metodología especializada',
        description: 'Marcos de trabajo adaptados a proyectos de IA',
      },
      {
        title: 'Gestión de riesgos',
        description: 'Identificación y mitigación de desafíos específicos de IA',
      },
      {
        title: 'Liderazgo efectivo',
        description: 'Dirección de equipos técnicos y stakeholders',
      },
      {
        title: 'Garantía de calidad',
        description: 'Procesos de validación y control específicos para IA',
      },
    ],
  },

  'Evaluación de impacto': {
    name: 'Evaluación de impacto',
    description:
      'Proporcionamos marcos metodológicos para medir y evaluar el impacto de las implementaciones de IA en la organización. Cubrimos definición de KPIs, métodos de medición, análisis de ROI y evaluación de impactos técnicos, operativos y organizacionales.',
    benefits: [
      {
        title: 'Medición objetiva',
        description: 'Frameworks cuantitativos para evaluar resultados',
      },
      {
        title: 'ROI verificable',
        description: 'Metodologías para calcular retorno de inversión en IA',
      },
      {
        title: 'Impacto integral',
        description: 'Evaluación de efectos en múltiples dimensiones organizacionales',
      },
      {
        title: 'Mejora continua',
        description: 'Procesos de optimización basados en resultados medidos',
      },
    ],
  },

  'Análisis de procesos clave': {
    name: 'Análisis de procesos clave',
    description:
      'Realizamos una evaluación exhaustiva de los procesos críticos que impulsan el valor en tu organización. Mediante metodologías avanzadas como Value Stream Mapping, Business Process Analysis y Lean Six Sigma, examinamos detalladamente cada proceso core, identificando interdependencias, cuellos de botella, desperdicios y oportunidades de optimización. Nuestro análisis abarca la eficiencia operativa, el impacto en la experiencia del cliente y la alineación con objetivos estratégicos.',
    benefits: [
      {
        title: 'Mapeo integral',
        description: 'Documentación detallada de flujos de trabajo y cadenas de valor',
      },
      {
        title: 'Identificación de ineficiencias',
        description: 'Detección de redundancias, desperdicios y cuellos de botella',
      },
      {
        title: 'Optimización de recursos',
        description: 'Recomendaciones para maximizar la eficiencia operativa',
      },
      {
        title: 'Mejora continua',
        description: 'Framework para monitoreo y optimización sistemática de procesos',
      },
    ],
  },

  'Evaluación de resultados': {
    name: 'Evaluación de resultados',
    description:
      'Implementamos un sistema integral de medición y evaluación del impacto de las iniciativas de transformación empresarial. Mediante KPIs estratégicos, cuadros de mando integral y análisis multidimensional, evaluamos el progreso y resultados de la transformación en aspectos clave como eficiencia operativa, innovación, cultura organizacional y creación de valor. Nuestro enfoque combina métricas cuantitativas y cualitativas para proporcionar una visión holística del éxito de la transformación.',
    benefits: [
      {
        title: 'Medición integral',
        description: 'Evaluación multidimensional del impacto en todas las áreas del negocio',
      },
      {
        title: 'ROI verificable',
        description: 'Cuantificación precisa del retorno de inversión en transformación',
      },
      {
        title: 'Ajuste estratégico',
        description: 'Refinamiento continuo de iniciativas basado en resultados medidos',
      },
      {
        title: 'Gestión del conocimiento',
        description: 'Documentación y capitalización de aprendizajes y mejores prácticas',
      },
    ],
  },

  'Diagnóstico de cultura actual': {
    name: 'Diagnóstico de cultura actual',
    description:
      'Realizamos una evaluación exhaustiva de la cultura organizacional existente mediante metodologías probadas como Cultural Assessment Framework y Organizational Culture Inventory. Analizamos valores, comportamientos, prácticas de trabajo, sistemas de reconocimiento y patrones de comunicación para comprender profundamente el ADN cultural de la organización.',
    benefits: [
      {
        title: 'Mapeo cultural integral',
        description: 'Identificación detallada de elementos culturales clave y su impacto',
      },
      {
        title: 'Análisis de brechas',
        description: 'Evaluación de distancia entre cultura actual y aspiracional',
      },
      {
        title: 'Insights accionables',
        description: 'Hallazgos específicos para guiar la transformación cultural',
      },
      {
        title: 'Base comparativa',
        description: 'Benchmark contra mejores prácticas del sector',
      },
    ],
  },

  'Diseño de cultura objetivo': {
    name: 'Diseño de cultura objetivo',
    description:
      'Definimos colaborativamente la cultura deseada que impulsará el éxito futuro de la organización. Mediante workshops participativos y alineación con la estrategia empresarial, establecemos valores core, comportamientos esperados y prácticas culturales que fomentarán la innovación, agilidad y excelencia operativa.',
    benefits: [
      {
        title: 'Alineación estratégica',
        description: 'Cultura diseñada para impulsar objetivos de negocio',
      },
      {
        title: 'Co-creación inclusiva',
        description: 'Participación activa de stakeholders clave en el diseño',
      },
      {
        title: 'Definición clara',
        description: 'Articulación precisa de valores y comportamientos deseados',
      },
      {
        title: 'Framework accionable',
        description: 'Guía práctica para implementación de cambios culturales',
      },
    ],
  },

  'Programas de cambio cultural': {
    name: 'Programas de cambio cultural',
    description:
      'Desarrollamos e implementamos iniciativas estructuradas para catalizar la transformación cultural. Combinamos programas de formación, comunicación estratégica, rediseño de procesos y sistemas de reconocimiento para impulsar la adopción de nuevos comportamientos y prácticas alineadas con la cultura objetivo.',
    benefits: [
      {
        title: 'Implementación sistemática',
        description: 'Enfoque estructurado para gestionar el cambio cultural',
      },
      {
        title: 'Adopción sostenible',
        description: 'Estrategias para asegurar cambios duraderos en comportamientos',
      },
      {
        title: 'Engagement efectivo',
        description: 'Involucramiento activo de todos los niveles organizacionales',
      },
      {
        title: 'Resultados medibles',
        description: 'Seguimiento concreto de avances en la transformación',
      },
    ],
  },

  'Liderazgo transformacional': {
    name: 'Liderazgo transformacional',
    description:
      'Desarrollamos las capacidades de los líderes para impulsar y sostener el cambio cultural. Mediante programas especializados, coaching ejecutivo y herramientas prácticas, equipamos a los líderes con las competencias necesarias para modelar la nueva cultura y guiar efectivamente a sus equipos durante la transformación.',
    benefits: [
      {
        title: 'Capacidades de cambio',
        description: 'Desarrollo de habilidades para liderar la transformación',
      },
      {
        title: 'Modelaje cultural',
        description: 'Líderes como ejemplos vivientes de la nueva cultura',
      },
      {
        title: 'Gestión de resistencia',
        description: 'Herramientas para manejar barreras al cambio cultural',
      },
      {
        title: 'Alineación ejecutiva',
        description: 'Cohesión del equipo directivo en la visión cultural',
      },
    ],
  },

  'Medición de evolución cultural': {
    name: 'Medición de evolución cultural',
    description:
      'Implementamos sistemas integrales para monitorear y evaluar el progreso de la transformación cultural. Mediante indicadores cuantitativos y cualitativos, medimos cambios en comportamientos, actitudes y resultados organizacionales, proporcionando insights actionables para ajustar y reforzar las iniciativas de cambio.',
    benefits: [
      {
        title: 'Métricas culturales',
        description: 'Indicadores específicos para seguimiento de cambios culturales',
      },
      {
        title: 'Feedback continuo',
        description: 'Sistemas de retroalimentación para ajuste de iniciativas',
      },
      {
        title: 'Impacto verificable',
        description: 'Medición del ROI de la transformación cultural',
      },
      {
        title: 'Insights accionables',
        description: 'Datos concretos para refinar estrategias de cambio',
      },
    ],
  },

  'Mapeo de journey del cliente': {
    name: 'Mapeo de journey del cliente',
    description:
      'Desarrollamos mapas detallados del viaje del cliente que visualizan todas las interacciones con tu organización. Mediante metodologías centradas en el usuario, documentamos cada punto de contacto, emociones, necesidades y expectativas del cliente en cada etapa, identificando momentos de verdad, pain points y oportunidades de mejora para crear experiencias memorables.',
    benefits: [
      {
        title: 'Visión integral',
        description: 'Comprensión holística de la experiencia del cliente en todos los canales',
      },
      {
        title: 'Identificación de fricciones',
        description: 'Detección precisa de obstáculos y frustraciones del cliente',
      },
      {
        title: 'Priorización estratégica',
        description: 'Enfoque en mejoras de mayor impacto en la satisfacción',
      },
      {
        title: 'Alineación organizacional',
        description: 'Visión compartida de la experiencia ideal del cliente',
      },
    ],
  },

  'Análisis de puntos de contacto': {
    name: 'Análisis de puntos de contacto',
    description:
      'Evaluamos en profundidad cada interacción cliente-empresa para optimizar la experiencia global. Mediante técnicas de investigación cualitativa y cuantitativa, analizamos la efectividad, eficiencia y satisfacción en cada touchpoint, identificando oportunidades de mejora y estandarización para garantizar una experiencia consistente y positiva.',
    benefits: [
      {
        title: 'Optimización multicanal',
        description: 'Mejora coordinada de interacciones en todos los canales',
      },
      {
        title: 'Consistencia experiencial',
        description: 'Estandarización de la calidad en todos los puntos de contacto',
      },
      {
        title: 'Eficiencia operativa',
        description: 'Reducción de redundancias y optimización de recursos',
      },
      {
        title: 'Personalización efectiva',
        description: 'Adaptación de interacciones según preferencias del cliente',
      },
    ],
  },

  'Diseño de experiencias': {
    name: 'Diseño de experiencias',
    description:
      'Creamos experiencias memorables y diferenciadas que fortalecen la conexión emocional con tus clientes. Mediante metodologías de diseño centrado en el usuario, desarrollamos soluciones innovadoras que combinan funcionalidad, usabilidad y elementos emocionales para superar expectativas y generar lealtad.',
    benefits: [
      {
        title: 'Diferenciación competitiva',
        description: 'Creación de experiencias únicas y memorables',
      },
      {
        title: 'Engagement emocional',
        description: 'Fortalecimiento del vínculo cliente-marca',
      },
      {
        title: 'Usabilidad optimizada',
        description: 'Interacciones intuitivas y satisfactorias',
      },
      {
        title: 'Innovación experiencial',
        description: 'Implementación de soluciones creativas y efectivas',
      },
    ],
  },

  'Implementación de mejoras': {
    name: 'Implementación de mejoras',
    description:
      'Ejecutamos iniciativas de optimización priorizadas para transformar la experiencia del cliente. Mediante un enfoque estructurado y ágil, implementamos mejoras incrementales y transformacionales, gestionando el cambio organizacional y asegurando la adopción efectiva de nuevas prácticas y tecnologías.',
    benefits: [
      {
        title: 'Implementación ágil',
        description: 'Despliegue iterativo con resultados tempranos',
      },
      {
        title: 'Gestión del cambio',
        description: 'Acompañamiento en la adopción de nuevas prácticas',
      },
      {
        title: 'Impacto medible',
        description: 'Seguimiento de mejoras con KPIs específicos',
      },
      {
        title: 'Escalabilidad',
        description: 'Soluciones diseñadas para crecer con el negocio',
      },
    ],
  },

  'Medición de satisfacción': {
    name: 'Medición de satisfacción',
    description:
      'Implementamos sistemas integrales de medición para evaluar la satisfacción y lealtad del cliente. Mediante metodologías probadas como NPS, CSAT y CES, combinadas con análisis cualitativo, monitoreamos continuamente la percepción del cliente y el impacto de las iniciativas de mejora.',
    benefits: [
      {
        title: 'Monitoreo continuo',
        description: 'Seguimiento en tiempo real de la satisfacción del cliente',
      },
      {
        title: 'Insights accionables',
        description: 'Identificación de áreas de mejora prioritarias',
      },
      {
        title: 'ROI verificable',
        description: 'Medición del impacto económico de mejoras implementadas',
      },
      {
        title: 'Benchmarking competitivo',
        description: 'Comparación con estándares de la industria',
      },
    ],
  },

  'Análisis de procesos actuales': {
    name: 'Análisis de procesos actuales',
    description:
      'Realizamos un diagnóstico exhaustivo de los procesos organizacionales mediante metodologías como Value Stream Mapping, Business Process Analysis y Lean Six Sigma. Evaluamos flujos de trabajo, roles, sistemas, documentación y métricas para identificar ineficiencias, redundancias, cuellos de botella y oportunidades de mejora, proporcionando una base sólida para el rediseño de procesos.',
    benefits: [
      {
        title: 'Mapeo integral',
        description: 'Documentación detallada de procesos y sus interrelaciones',
      },
      {
        title: 'Identificación de desperdicios',
        description: 'Detección de actividades que no agregan valor',
      },
      {
        title: 'Análisis de causa raíz',
        description: 'Determinación de factores que generan ineficiencias',
      },
      {
        title: 'Benchmark sectorial',
        description: 'Comparación con mejores prácticas de la industria',
      },
    ],
  },

  'Diseño de nuevos procesos': {
    name: 'Diseño de nuevos procesos',
    description:
      'Desarrollamos procesos optimizados que maximizan la eficiencia operativa y el valor entregado. Mediante metodologías de diseño centrado en el usuario y principios Lean, creamos flujos de trabajo intuitivos, escalables y adaptables que eliminan actividades sin valor, reducen tiempos de ciclo y mejoran la calidad de resultados.',
    benefits: [
      {
        title: 'Optimización end-to-end',
        description: 'Mejora integral de flujos de trabajo completos',
      },
      {
        title: 'Simplificación operativa',
        description: 'Reducción de complejidad y pasos innecesarios',
      },
      {
        title: 'Integración tecnológica',
        description: 'Incorporación de herramientas digitales habilitadoras',
      },
      {
        title: 'Escalabilidad futura',
        description: 'Diseños adaptables al crecimiento organizacional',
      },
    ],
  },

  'Automatización de flujos': {
    name: 'Automatización de flujos',
    description:
      'Implementamos soluciones tecnológicas que automatizan tareas repetitivas y estandarizan procesos clave. Mediante herramientas de BPM, RPA y workflow automation, desarrollamos flujos digitales que reducen intervención manual, minimizan errores y aceleran tiempos de proceso, permitiendo a los equipos enfocarse en actividades de mayor valor.',
    benefits: [
      {
        title: 'Eficiencia operativa',
        description: 'Reducción significativa en tiempos de procesamiento',
      },
      {
        title: 'Consistencia y calidad',
        description: 'Estandarización de procesos y eliminación de errores',
      },
      {
        title: 'Trazabilidad completa',
        description: 'Seguimiento detallado de cada instancia del proceso',
      },
      {
        title: 'Integración sistemas',
        description: 'Conexión fluida entre diferentes plataformas',
      },
    ],
  },

  'Medición de eficiencia': {
    name: 'Medición de eficiencia',
    description:
      'Implementamos sistemas de medición y monitoreo que evalúan el rendimiento de los procesos optimizados. Mediante KPIs específicos, dashboards en tiempo real y análisis periódicos, monitoreamos la efectividad de las mejoras implementadas, identificamos desviaciones y generamos insights para la mejora continua.',
    benefits: [
      {
        title: 'Métricas objetivas',
        description: 'Indicadores cuantitativos de rendimiento operativo',
      },
      {
        title: 'Monitoreo continuo',
        description: 'Seguimiento en tiempo real del desempeño de procesos',
      },
      {
        title: 'ROI verificable',
        description: 'Medición del impacto económico de las mejoras',
      },
      {
        title: 'Mejora iterativa',
        description: 'Optimización continua basada en datos reales',
      },
    ],
  },
};

export function getFeatureDetails(featureName: string): ServiceFeature {
  // Si existe la característica en el objeto featureDetails, la devolvemos
  if (featureDetails[featureName]) {
    return featureDetails[featureName];
  }

  // Si no existe, devolvemos un objeto por defecto
  return {
    name: featureName,
    description: 'Información detallada próximamente.',
    benefits: [
      {
        title: 'Beneficio',
        description: 'Detalles próximamente',
      },
    ],
  };
}
